<!--NUEVO DISEÑO-->

<!-- ============================= MODAL CERTIFICADO (mismo diseño que academy/certificates) ============================= -->
<div class="fixed inset-0 bg-[#22304C]/60 backdrop-blur-sm items-center justify-center p-4 z-[999999]"
  [ngClass]="showCertModal ? 'flex' : 'hidden'" (click)="closeCertModal()">
  <div class="relative w-full max-w-md rounded-3xl overflow-hidden bg-white shadow-2xl"
    (click)="$event.stopPropagation()">

    <!-- Confetti -->
    <div class="cert-confetti pointer-events-none absolute inset-0 overflow-hidden">
      <span *ngFor="let p of confettiPieces"
        [style.left.%]="p.left"
        [style.width.px]="p.width"
        [style.height.px]="p.height"
        [style.background-color]="p.color"
        [style.border-radius.px]="p.radius"
        [style.animation]="'certConfetti ' + p.duration + 's linear ' + p.delay + 's infinite'"></span>
    </div>

    <!-- Header: logo + cerrar -->
    <div class="relative flex items-center justify-between px-6 py-4">
      <img *ngIf="selectedCertificate?.providerLogo" [src]="selectedCertificate.providerLogo" [alt]="selectedCertificate?.providerName"
        class="h-7 w-auto max-w-[100px] object-contain" (error)="onLogoError($event, selectedCertificate)">
      <span *ngIf="!selectedCertificate?.providerLogo" class="text-base font-bold text-[#22304C]">{{ selectedCertificate?.providerName }}</span>
      <button (click)="closeCertModal()" aria-label="Cerrar"
        class="w-9 h-9 rounded-full border border-gray-200 bg-white/80 text-[#5F6877] hover:text-[#22304C] hover:bg-[#F6F7F9] flex items-center justify-center transition-colors">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-x w-4 h-4"><path d="M18 6 6 18"></path><path d="m6 6 12 12"></path></svg>
      </button>
    </div>

    <!-- Cuerpo -->
    <div class="relative px-8 pt-2 pb-8 text-center">
      <h2 class="text-2xl mb-4 font-semibold text-[#22304C] tracking-tight">¡Felicitaciones!</h2>
      <p class="mt-1.5 text-[15px] text-[#5F6877]">Completaste el curso y tu certificado ya está listo.</p>

      <div class="my-6 h-px bg-gray-200"></div>

      <div class="text-[11px] font-semibold uppercase tracking-[0.14em] text-[#7C7A66]">Certificado de finalización</div>
      <h3 class="mt-2 font-semibold text-xl leading-[1.3] text-[#1B1B1B] truncate" [title]="selectedCertificate?.contentName">{{ selectedCertificate?.contentName }}</h3>
      <p class="mt-3 text-[13px] text-[#5F6877]">{{ selectedCertificate?.certificatedDate | date:'MMM d, y' }}</p>

      <div class="my-6 h-px bg-gray-200"></div>

      <!-- Botón principal: descarga + destello -->
      <a [href]="selectedCertificate?.certificatePath" target="_blank" rel="noopener noreferrer"
        class="cert-shine group relative w-full h-14 rounded-full bg-[#22304C] hover:bg-[#1B2540] text-white text-sm font-bold inline-flex items-center justify-center gap-2.5 transition-all overflow-hidden hover:-translate-y-0.5"
        style="box-shadow: 0 20px 50px -20px rgba(34,48,76,0.55);">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-download w-4 h-4"><path d="M21 15v4a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2v-4"></path><polyline points="7 10 12 15 17 10"></polyline><line x1="12" x2="12" y1="15" y2="3"></line></svg>
        {{ 'words.download-certificate' | translate }}
      </a>

      <p class="mt-4 text-[13px] text-[#5F6877]">Disponible siempre en Tus certificados</p>
    </div>
  </div>
</div>

<!-- ============================= MODAL COMPARTIR ============================= -->
<!-- Fuera del sidebar (que es sticky y crea su propio stacking context) para que el z-index -->
<!-- alto sí gane sobre el navbar/hero, en vez de quedar acotado dentro del sidebar. -->
<div *ngIf="showShareMenu" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[1000000] p-4"
    (click)="closeShare()">
    <div class="w-full max-w-xs rounded-lg border border-gray-200 bg-white shadow-xl p-4"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between mb-3">
            <p class="text-sm font-bold text-gray-700">{{ "words.share-profile" | translate }}</p>
            <button type="button" (click)="closeShare()" aria-label="Cerrar"
                class="text-gray-400 hover:text-gray-700 transition-colors">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="lucide lucide-x w-4 h-4">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>
        <div class="grid grid-cols-4 gap-1.5">
            <a [href]="shareFacebook" target="_blank" rel="noopener noreferrer" title="Facebook"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="lucide lucide-facebook w-5 h-5 text-[#1877F2]">
                    <path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"></path>
                </svg>
                <span class="text-[11px] text-gray-600">Facebook</span>
            </a>
            <a [href]="shareTwitter" target="_blank" rel="noopener noreferrer" title="Twitter"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="lucide lucide-twitter w-5 h-5 text-[#1DA1F2]">
                    <path
                        d="M22 4s-.7 2.1-2 3.4c1.6 10-9.4 17.3-18 11.6 2.2.1 4.4-.6 6-2C3 15.5.5 9.6 3 5c2.2 2.6 5.6 4.1 9 4-.9-4.2 4-6.6 7-3.8 1.1 0 3-1.2 3-1.2z">
                    </path>
                </svg>
                <span class="text-[11px] text-gray-600">Twitter</span>
            </a>
            <a [href]="shareLinkedIn" target="_blank" rel="noopener noreferrer" title="LinkedIn"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="lucide lucide-linkedin w-5 h-5 text-[#0A66C2]">
                    <path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-2-2 2 2 0 0 0-2 2v7h-4v-7a6 6 0 0 1 6-6z">
                    </path>
                    <rect width="4" height="12" x="2" y="9"></rect>
                    <circle cx="4" cy="4" r="2"></circle>
                </svg>
                <span class="text-[11px] text-gray-600">LinkedIn</span>
            </a>
            <a [href]="shareEmail" target="_blank" rel="noopener noreferrer" title="Email"
                class="flex flex-col items-center gap-1 rounded-lg py-2 hover:bg-gray-50 transition">
                <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24"
                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                    stroke-linejoin="round" class="lucide lucide-mail w-5 h-5 text-gray-600">
                    <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                </svg>
                <span class="text-[11px] text-gray-600">Email</span>
            </a>
        </div>
        <button type="button" (click)="copyLink()"
            class="mt-2 w-full inline-flex items-center justify-center gap-2 text-xs font-medium rounded-lg py-2 bg-gray-100 hover:bg-gray-200 text-gray-700 transition">
            <svg xmlns="http://www.w3.org/2000/svg" width="26" height="26" viewBox="0 0 24 24" fill="none"
                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                class="lucide lucide-link w-3.5 h-3.5">
                <path d="M10 13a5 5 0 0 0 7.54.54l3-3a5 5 0 0 0-7.07-7.07l-1.72 1.71"></path>
                <path d="M14 11a5 5 0 0 0-7.54-.54l-3 3a5 5 0 0 0 7.07 7.07l1.71-1.71"></path>
            </svg>
            {{ linkCopied ? ("words.link-copied" | translate) : ("words.copy-link" | translate) }}
        </button>
    </div>
</div>

<!-- ============================= MODAL IMPORTAR PERFIL ============================= -->
<input #cvFileInput type="file" accept=".pdf,.docx" class="hidden" (change)="onCvFileSelected($event)">

<div *ngIf="showImportModal" class="fixed inset-0 bg-black bg-opacity-40 flex items-center justify-center z-[1000000] p-4"
  (click)="cvImportStatus === 'preview' ? null : closeImportModal()">
  <div class="w-full rounded-lg bg-white shadow-xl p-5" [class.max-w-sm]="cvImportStatus !== 'preview'"
    [class.max-w-lg]="cvImportStatus === 'preview'" (click)="$event.stopPropagation()">

    <!-- Estado inicial: elegir origen -->
    <ng-container *ngIf="cvImportStatus === 'idle'">
      <div class="flex items-center justify-between">
        <h3 class="text-base font-bold text-gray-700">{{ "words.import-profile" | translate }}</h3>
        <button type="button" (click)="closeImportModal()" aria-label="Cerrar"
          class="text-gray-400 hover:text-gray-700 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-x w-4 h-4">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
      <p class="mt-3 text-sm text-gray-500">{{ "words.import-profile-choose" | translate }}</p>

      <div class="mt-4 space-y-2">
        <!-- Importar desde LinkedIn: pospuesto — la API pública de LinkedIn no permite
             traer experiencia/educación sin ser socio aprobado (ver commit de esta fecha). -->
        <button type="button" (click)="triggerCvUpload()"
          class="w-full flex items-center gap-3 rounded-lg border border-gray-200 p-3 text-left gk-btn-outline transition">
          <span class="w-9 h-9 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
              stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
              class="lucide lucide-file-text w-4 h-4 text-gray-700">
              <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
              <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
              <path d="M16 13H8"></path>
              <path d="M16 17H8"></path>
              <path d="M10 9H8"></path>
            </svg>
          </span>
          <span class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-gray-700">{{ "words.import-from-cv" | translate }}</p>
            <p class="text-[11px] text-gray-500">{{ "words.import-from-cv-desc" | translate }}</p>
          </span>
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
            class="lucide lucide-chevron-right w-4 h-4 text-gray-400 shrink-0">
            <path d="m9 18 6-6-6-6"></path>
          </svg>
        </button>
      </div>
    </ng-container>

    <!-- Estado: subiendo / procesando con IA -->
    <ng-container *ngIf="cvImportStatus === 'uploading' || cvImportStatus === 'processing'">
      <div class="flex flex-col items-center text-center py-6">
        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
          stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
          class="lucide lucide-loader-circle w-8 h-8 text-primary animate-spin">
          <path d="M21 12a9 9 0 1 1-6.219-8.56"></path>
        </svg>
        <p class="mt-3 text-sm font-semibold text-gray-700">
          {{ cvImportStatus === 'uploading' ? 'Subiendo tu CV…' : 'Leyendo tu CV con IA…' }}
        </p>
        <p class="mt-1 text-xs text-gray-500">Esto puede tardar unos segundos.</p>
      </div>
    </ng-container>

    <!-- Estado: error -->
    <ng-container *ngIf="cvImportStatus === 'error'">
      <div class="flex items-center justify-between">
        <h3 class="text-base font-bold text-gray-700">No se pudo importar</h3>
        <button type="button" (click)="cancelCvImportPreview()" aria-label="Cerrar"
          class="text-gray-400 hover:text-gray-700 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
      <p class="mt-3 text-sm text-gray-500">{{ cvImportErrorMessage }}</p>
      <div class="mt-4 flex items-center justify-end gap-3">
        <button type="button" (click)="cancelCvImportPreview()"
          class="rounded-full border border-gray-300 px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
          Cerrar
        </button>
        <button type="button" (click)="triggerCvUpload()"
          class="rounded-full bg-primary text-white px-4 py-2 text-xs font-semibold hover:opacity-90 transition">
          Reintentar
        </button>
      </div>
    </ng-container>

    <!-- Estado: previsualización editable antes de guardar -->
    <ng-container *ngIf="cvImportStatus === 'preview' && cvPreview">
      <div class="flex items-center justify-between">
        <h3 class="text-base font-bold text-gray-700">Revisa lo que encontramos</h3>
        <button type="button" (click)="cancelCvImportPreview()" aria-label="Cerrar"
          class="text-gray-400 hover:text-gray-700 transition-colors">
          <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="w-4 h-4">
            <path d="M18 6 6 18"></path>
            <path d="m6 6 12 12"></path>
          </svg>
        </button>
      </div>
      <p class="mt-2 text-xs text-gray-500">Desmarca lo que no quieras agregar a tu perfil.</p>

      <div class="mt-4 max-h-[50vh] overflow-y-auto space-y-4 pr-1">
        <div *ngIf="cvPreview.experiences.length">
          <p class="text-[11px] font-bold uppercase tracking-[0.12em] text-gray-400">Experiencia laboral</p>
          <label *ngFor="let exp of cvPreview.experiences; let i = index"
            class="mt-2 flex items-start gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer">
            <input type="checkbox" [checked]="exp.selected" (change)="toggleCvPreviewItem('experiences', i)"
              class="mt-0.5 rounded border-gray-300 text-primary focus:ring-primary">
            <span class="min-w-0 flex-1">
              <p class="text-sm font-semibold text-gray-700">{{ exp.title }} <span
                  *ngIf="exp.companyName" class="font-normal text-gray-500">· {{ exp.companyName }}</span></p>
              <p class="text-xs text-gray-500">{{ exp.startYear || '—' }} - {{ exp.isCurrent ? 'Actualidad' : (exp.endYear || '—') }}</p>
            </span>
          </label>
        </div>

        <div *ngIf="cvPreview.education.length">
          <p class="text-[11px] font-bold uppercase tracking-[0.12em] text-gray-400">Educación</p>
          <label *ngFor="let edu of cvPreview.education; let i = index"
            class="mt-2 flex items-start gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer">
            <input type="checkbox" [checked]="edu.selected" (change)="toggleCvPreviewItem('education', i)"
              class="mt-0.5 rounded border-gray-300 text-primary focus:ring-primary">
            <span class="min-w-0 flex-1">
              <p class="text-sm font-semibold text-gray-700">{{ edu.university }}</p>
              <p class="text-xs text-gray-500">{{ cvEducationLabel(edu) }}</p>
            </span>
          </label>
        </div>

        <div *ngIf="cvPreview.externalCertifications.length">
          <p class="text-[11px] font-bold uppercase tracking-[0.12em] text-gray-400">Certificaciones externas</p>
          <label *ngFor="let cert of cvPreview.externalCertifications; let i = index"
            class="mt-2 flex items-start gap-3 rounded-lg border border-gray-200 p-3 cursor-pointer">
            <input type="checkbox" [checked]="cert.selected" (change)="toggleCvPreviewItem('externalCertifications', i)"
              class="mt-0.5 rounded border-gray-300 text-primary focus:ring-primary">
            <span class="min-w-0 flex-1">
              <p class="text-sm font-semibold text-gray-700">{{ cert.name }}</p>
              <p class="text-xs text-gray-500">{{ cert.issuer }}</p>
            </span>
          </label>
        </div>

        <p *ngIf="!cvPreview.experiences.length && !cvPreview.education.length && !cvPreview.externalCertifications.length"
          class="text-sm text-gray-500 text-center py-4">
          No encontramos experiencia, educación ni certificaciones en este archivo.
        </p>
      </div>

      <div class="mt-4 flex items-center justify-end gap-3">
        <button type="button" (click)="cancelCvImportPreview()"
          class="rounded-full border border-gray-300 px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
          Cancelar
        </button>
        <button type="button" (click)="confirmCvImportPreview()"
          class="rounded-full bg-primary text-white px-4 py-2 text-xs font-semibold hover:opacity-90 transition">
          Agregar seleccionados
        </button>
      </div>
    </ng-container>
  </div>
</div>

<!-- ============================================================= -->
<!-- MODAL: Agregar experiencia (CON LOGICA mock: sin persistencia en backend aún) -->
<!-- ============================================================= -->
<div *ngIf="showExperienceModal" class="fixed inset-0 z-[1000000] flex items-center justify-center bg-black/40 p-4"
    (click)="closeModals()">
    <div class="bg-white w-full max-w-lg rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h3 class="text-base font-bold text-gray-700">{{ "words.add-experience" | translate }}</h3>
            <button (click)="closeModals()" aria-label="Cerrar" class="text-gray-400 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-5 h-5">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>

        <div class="px-6 py-5 space-y-4">
            <!-- Cargo -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.position" | translate }} <span
                        class="text-red-500">*</span></label>
                <input type="text" [(ngModel)]="expForm.title" name="expTitle" placeholder="Ej. Senior Developer"
                    class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
            </div>

            <!-- Empresa (autocomplete) -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.company" | translate }} <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <input type="text" [(ngModel)]="expForm.company" (ngModelChange)="onCompanyInput()"
                        name="expCompany" autocomplete="off"
                        [placeholder]="expForm.companyManual ? ('words.type-company-name' | translate) : ('words.search-your-company' | translate)"
                        class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
                    <div *ngIf="showCompanySuggestions"
                        class="absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg max-h-48 overflow-auto">
                        <button type="button" *ngFor="let c of filteredCompanies" (click)="selectCompany(c)"
                            class="w-full text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50">{{ c }}</button>
                        <button type="button" (click)="enableManualCompany()"
                            class="w-full text-left px-3 py-2 text-xs text-primary border-t border-gray-100 hover:bg-gray-50">{{
                            "words.company-not-found" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Fecha inicio -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.start-date" | translate }} <span
                        class="text-red-500">*</span></label>
                <div class="grid grid-cols-2 gap-2">
                    <select [(ngModel)]="expForm.startMonth" name="expStartMonth"
                        class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                        <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                        <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                    </select>
                    <select [(ngModel)]="expForm.startYear" name="expStartYear"
                        class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                        <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                        <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                    </select>
                </div>
            </div>

            <!-- Actualmente trabajo aquí -->
            <label class="flex items-center gap-2 text-sm text-gray-700 select-none">
                <input type="checkbox" [(ngModel)]="expForm.current" name="expCurrent"
                    class="rounded border-gray-300 text-primary focus:ring-primary">
                {{ "words.currently-work-here" | translate }}
            </label>

            <!-- Fecha fin -->
            <div [class.opacity-50]="expForm.current">
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.end-date" | translate }}</label>
                <div class="grid grid-cols-2 gap-2">
                    <select [(ngModel)]="expForm.endMonth" name="expEndMonth" [disabled]="expForm.current"
                        class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed">
                        <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                        <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                    </select>
                    <select [(ngModel)]="expForm.endYear" name="expEndYear" [disabled]="expForm.current"
                        class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary disabled:cursor-not-allowed">
                        <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                        <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                    </select>
                </div>
            </div>

            <!-- Descripción -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.description" | translate }} <span
                        class="text-gray-400 font-normal">({{ "words.optional" | translate | lowercase }})</span></label>
                <textarea [(ngModel)]="expForm.description" name="expDescription" rows="3"
                    [placeholder]="'words.describe-responsibilities' | translate"
                    class="w-full rounded-md border border-gray-300 px-3 py-2 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary resize-y"></textarea>
            </div>
        </div>

        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
            <button (click)="closeModals()"
                class="rounded-full border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 gk-btn-outline transition">{{
                "words.cancel" | translate }}</button>
            <button (click)="saveExperience()"
                [disabled]="!expForm.title || !expForm.company || !expForm.startYear"
                class="inline-flex items-center rounded-full bg-primary text-white px-5 py-2 text-sm font-semibold hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition">{{
                "common.save" | translate }}</button>
        </div>
    </div>
</div>

<!-- ============================================================= -->
<!-- MODAL: Agregar educación (CON LOGICA mock: sin persistencia en backend aún) -->
<!-- ============================================================= -->
<div *ngIf="showEducationModal" class="fixed inset-0 z-[1000000] flex items-center justify-center bg-black/40 p-4"
    (click)="closeModals()">
    <div class="bg-white w-full max-w-lg rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h3 class="text-base font-bold text-gray-700">{{ "words.add-education" | translate }}</h3>
            <button (click)="closeModals()" aria-label="Cerrar" class="text-gray-400 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-5 h-5">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>

        <div class="px-6 py-5 space-y-4">
            <!-- País -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.country" | translate }} <span
                        class="text-red-500">*</span></label>
                <select [(ngModel)]="eduForm.country" (ngModelChange)="onCountryChange()" name="eduCountry"
                    class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                    <option *ngFor="let c of countryOptions" [ngValue]="c">{{ c }}</option>
                </select>
            </div>

            <!-- Universidad (autocomplete filtrado por país) -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.university" | translate }} <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <input type="text" [(ngModel)]="eduForm.university" (ngModelChange)="onUniversityInput()"
                        name="eduUniversity" autocomplete="off"
                        [placeholder]="eduForm.universityManual ? ('words.type-university-name' | translate) : ('words.search-your-university' | translate)"
                        class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
                    <div *ngIf="showUniversitySuggestions"
                        class="absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg max-h-48 overflow-auto">
                        <button type="button" *ngFor="let u of filteredUniversities" (click)="selectUniversity(u)"
                            class="w-full text-left px-3 py-2 hover:bg-gray-50">
                            <span class="block text-sm text-gray-700">{{ u.name }}</span>
                            <span class="block text-[11px] text-gray-400">{{ u.city }}</span>
                        </button>
                        <button type="button" (click)="enableManualUniversity()"
                            class="w-full text-left px-3 py-2 text-xs text-primary border-t border-gray-100 hover:bg-gray-50">{{
                            "words.university-not-found" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Título obtenido -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.degree-obtained" | translate }}</label>
                <select [(ngModel)]="eduForm.degree" name="eduDegree"
                    class="h-9 w-full rounded-md border border-gray-300 bg-white px-3 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                    <option [ngValue]="''" disabled>{{ "words.select-a-degree" | translate }}</option>
                    <option *ngFor="let d of degreeOptions" [ngValue]="d">{{ d }}</option>
                </select>
            </div>

            <!-- Área de estudio -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.study-area" | translate }}</label>
                <input type="text" list="studyAreas" [(ngModel)]="eduForm.area" name="eduArea"
                    placeholder="Ej. Ingeniería de Software"
                    class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
                <datalist id="studyAreas">
                    <option *ngFor="let s of studyAreaSuggestions" [value]="s"></option>
                </datalist>
            </div>

            <!-- Fechas -->
            <div class="grid grid-cols-2 gap-3">
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.start-date" | translate }} <span
                            class="text-red-500">*</span></label>
                    <div class="grid grid-cols-2 gap-2">
                        <select [(ngModel)]="eduForm.startMonth" name="eduStartMonth"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                            <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                        </select>
                        <select [(ngModel)]="eduForm.startYear" name="eduStartYear"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.end-date" | translate }}</label>
                    <div class="grid grid-cols-2 gap-2">
                        <select [(ngModel)]="eduForm.endMonth" name="eduEndMonth"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                            <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                        </select>
                        <select [(ngModel)]="eduForm.endYear" name="eduEndYear"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>

        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
            <button (click)="closeModals()"
                class="rounded-full border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 gk-btn-outline transition">{{
                "words.cancel" | translate }}</button>
            <button (click)="saveEducation()" [disabled]="!eduForm.university || !eduForm.startYear"
                class="inline-flex items-center rounded-full bg-primary text-white px-5 py-2 text-sm font-semibold hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition">{{
                "common.save" | translate }}</button>
        </div>
    </div>
</div>

<!-- ============================================================= -->
<!-- MODAL: Agregar certificación (CON LOGICA mock: sin persistencia en backend aún) -->
<!-- ============================================================= -->
<div *ngIf="showCertificationModal" class="fixed inset-0 z-[1000000] flex items-center justify-center bg-black/40 p-4"
    (click)="closeModals()">
    <div class="bg-white w-full max-w-lg rounded-lg shadow-2xl max-h-[90vh] overflow-y-auto"
        (click)="$event.stopPropagation()">
        <div class="flex items-center justify-between px-6 py-4 border-b border-gray-100">
            <h3 class="text-base font-bold text-gray-700">{{ "words.add-certification" | translate }}</h3>
            <button (click)="closeModals()" aria-label="Cerrar" class="text-gray-400 hover:text-gray-700">
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                    stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                    class="w-5 h-5">
                    <path d="M18 6 6 18"></path>
                    <path d="m6 6 12 12"></path>
                </svg>
            </button>
        </div>

        <div class="px-6 py-5 space-y-4">
            <!-- Nombre del certificado -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.certification-name" | translate }} <span
                        class="text-red-500">*</span></label>
                <input type="text" [(ngModel)]="certForm.name" name="certName" placeholder="Ej. Developer Front End"
                    class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
            </div>

            <!-- Organismo emisor (autocomplete con logos) -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.issuing-organization" | translate }} <span
                        class="text-red-500">*</span></label>
                <div class="relative">
                    <input type="text" [(ngModel)]="certForm.issuer" (ngModelChange)="onIssuerInput()" name="certIssuer"
                        autocomplete="off"
                        [placeholder]="certForm.issuerManual ? ('words.type-issuer-name' | translate) : ('words.search-issuer' | translate)"
                        class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
                    <div *ngIf="showIssuerSuggestions"
                        class="absolute z-10 mt-1 w-full rounded-md border border-gray-200 bg-white shadow-lg max-h-48 overflow-auto">
                        <button type="button" *ngFor="let i of filteredIssuers" (click)="selectIssuer(i)"
                            class="w-full flex items-center gap-2 text-left px-3 py-2 text-sm text-gray-700 hover:bg-gray-50">
                            <img *ngIf="i.logo" [src]="i.logo" [alt]="i.name" class="w-5 h-5 object-contain">
                            <span>{{ i.name }}</span>
                        </button>
                        <button type="button" (click)="enableManualIssuer()"
                            class="w-full text-left px-3 py-2 text-xs text-primary border-t border-gray-100 hover:bg-gray-50">{{
                            "words.issuer-not-found" | translate }}</button>
                    </div>
                </div>
            </div>

            <!-- Fechas -->
            <div class="grid grid-cols-2 gap-3">
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.issue-date" | translate }} <span
                            class="text-red-500">*</span></label>
                    <div class="grid grid-cols-2 gap-2">
                        <select [(ngModel)]="certForm.issueMonth" name="certIssueMonth"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                            <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                        </select>
                        <select [(ngModel)]="certForm.issueYear" name="certIssueYear"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                        </select>
                    </div>
                </div>
                <div>
                    <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.expiration-date" | translate }} <span
                            class="text-gray-400 font-normal">({{ "words.optional" | translate | lowercase }})</span></label>
                    <div class="grid grid-cols-2 gap-2">
                        <select [(ngModel)]="certForm.expMonth" name="certExpMonth"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.month" | translate }}</option>
                            <option *ngFor="let m of months" [ngValue]="m.v">{{ m.l }}</option>
                        </select>
                        <select [(ngModel)]="certForm.expYear" name="certExpYear"
                            class="h-9 w-full rounded-md border border-gray-300 bg-white px-2 text-sm focus:outline-none focus:ring-1 focus:ring-primary">
                            <option [ngValue]="null" disabled>{{ "words.year" | translate }}</option>
                            <option *ngFor="let y of years" [ngValue]="y">{{ y }}</option>
                        </select>
                    </div>
                </div>
            </div>

            <!-- URL de verificación -->
            <div>
                <label class="block text-xs font-semibold text-gray-700 mb-1">{{ "words.verification-url" | translate }} <span
                        class="text-gray-400 font-normal">({{ "words.optional" | translate | lowercase }})</span></label>
                <input type="url" [(ngModel)]="certForm.url" name="certUrl"
                    placeholder="https://credly.com/..."
                    class="flex h-9 w-full rounded-md border border-gray-300 px-3 py-1.5 text-sm shadow-sm placeholder:text-gray-400 focus:outline-none focus:ring-1 focus:ring-primary">
            </div>
        </div>

        <div class="flex items-center justify-end gap-3 px-6 py-4 border-t border-gray-100">
            <button (click)="closeModals()"
                class="rounded-full border border-gray-300 px-5 py-2 text-sm font-semibold text-gray-700 gk-btn-outline transition">{{
                "words.cancel" | translate }}</button>
            <button (click)="saveCertification()"
                [disabled]="!certForm.name || !certForm.issuer || !certForm.issueYear"
                class="inline-flex items-center rounded-full bg-primary text-white px-5 py-2 text-sm font-semibold hover:opacity-90 disabled:opacity-40 disabled:cursor-not-allowed transition">{{
                "common.save" | translate }}</button>
        </div>
    </div>
</div>

<div class="bg-gray-50 min-h-screen">
    <main class="flex-1 py-14 md:py-6">
        <div class="mx-auto max-w-7xl grid grid-cols-1 lg:grid-cols-[280px_1fr] gap-5">

            <!-- ===================== SIDEBAR ===================== -->
            <aside class="flex flex-col w-full shrink-0 self-start gap-3">

                <!-- Botón para desplegar el sidebar en móvil (avatar + nombre + flecha).
                     En escritorio (lg+) no se muestra: el sidebar ya está siempre visible. -->
                <button type="button" (click)="showMobileProfileSidebar = !showMobileProfileSidebar"
                    class="academy-mobile-sidebar-toggle items-center justify-between gap-3 w-full bg-white border border-gray-100 box-cards px-4 py-3">
                    <div class="flex items-center gap-3 min-w-0">
                        <div class="w-10 h-10 rounded-full overflow-hidden shrink-0 academy-profile-avatar">
                            <img *ngIf="hasUploadedPicture" [src]="me.picture + '?size=128'" [alt]="me.name"
                                class="w-full h-full object-cover">
                            <svg *ngIf="!hasUploadedPicture" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                stroke-linecap="round" stroke-linejoin="round" class="academy-profile-avatar__icon">
                                <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                <circle cx="12" cy="7" r="4"></circle>
                            </svg>
                        </div>
                        <div class="min-w-0 text-left">
                            <p class="text-sm font-semibold text-gray-700 truncate">{{ shortName }}</p>
                            <p class="text-xs text-gray-500 truncate">{{ "words.my-profile" | translate }}</p>
                        </div>
                    </div>
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                        class="lucide lucide-chevron-down w-4 h-4 text-gray-400 shrink-0 transition-transform"
                        [class.rotate-180]="showMobileProfileSidebar">
                        <path d="m6 9 6 6 6-6"></path>
                    </svg>
                </button>

                <div class="academy-mobile-sidebar-content" [class.is-open]="showMobileProfileSidebar">

                <!-- Tarjeta de perfil (CON LOGICA: me.name / userLevel) -->
                <div class="relative rounded-lg overflow-hidden bg-white border border-gray-100 box-cards">
                    <div class="h-16 bg-gray-100"></div>
                    <div class="px-5 pb-5 -mt-12 text-center">
                        <div class="relative inline-block">
                            <div class="w-24 h-24 rounded-full p-[3px] bg-white ring-2 ring-[#ffffff] mx-auto shadow-[0_12px_35px_-18px_rgba(11,23,54,0.25)]">
                                <div class="w-full h-full rounded-full academy-profile-avatar">
                                    <img *ngIf="hasUploadedPicture" [src]="me.picture + '?size=256'" [alt]="me.name"
                                        class="w-full h-full rounded-full object-cover">
                                    <svg *ngIf="!hasUploadedPicture" xmlns="http://www.w3.org/2000/svg" width="24"
                                        height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor"
                                        stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                        class="academy-profile-avatar__icon">
                                        <path d="M19 21v-2a4 4 0 0 0-4-4H9a4 4 0 0 0-4 4v2"></path>
                                        <circle cx="12" cy="7" r="4"></circle>
                                    </svg>
                                </div>
                            </div>
                            <span *ngIf="userLevel && grikySkillsEnabled"
                                class="absolute -bottom-1 left-1/2 -translate-x-1/2 inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[10px] font-semibold text-white whitespace-nowrap bg-gray-700">
                                <svg class="academy-mobile-only w-2.5 h-2.5 shrink-0" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="currentColor" stroke="none">
                                    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"></path>
                                </svg>
                                {{ "words.level" | translate }} {{ userLevel }}</span>
                        </div>
                        <p class="mt-4 text-base font-bold text-gray-700">{{ shortName }}</p>
                        <p class="mt-0.5 text-xs text-gray-500">
                            <ng-container *ngIf="me?.headline; else studentDefault">{{ me.headline }}</ng-container>
                            <ng-template #studentDefault>{{ "words.student-of" | translate }} {{ company?.name ||
                                company?.experience?.name }}</ng-template>
                        </p>

                        <!-- Escritorio: botones pill (sin cambios) -->
                        <div class="academy-desktop-only mt-4 space-y-2">
                            <div class="flex items-center gap-2">
                                <button [routerLink]="['/account', 'profile']"
                                    class="flex-1 inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5 shrink-0">
                                        <path
                                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                        </path>
                                        <path d="m15 5 4 4"></path>
                                    </svg>
                                    {{ "words.edit" | translate }}
                                </button>
                                <div class="relative">
                                    <button type="button" aria-label="Compartir" (click)="toggleShare()"
                                        class="inline-flex items-center justify-center gap-2 border border-gray-300 bg-white text-xs font-semibold text-gray-700 gk-btn-outline transition px-4 py-2 rounded-full">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-share2 w-3.5 h-3.5 shrink-0">
                                            <circle cx="18" cy="5" r="3"></circle>
                                            <circle cx="6" cy="12" r="3"></circle>
                                            <circle cx="18" cy="19" r="3"></circle>
                                            <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                                            <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                                        </svg>
                                        {{ "words.share" | translate }}
                                    </button>
                                </div>
                            </div>
                            <button type="button" (click)="viewAsVisitor()"
                                class="w-full inline-flex items-center justify-center gap-2 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-eye w-3.5 h-3.5 shrink-0">
                                    <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0">
                                    </path>
                                    <circle cx="12" cy="12" r="3"></circle>
                                </svg>
                                {{ "words.view-as-visitor" | translate }}
                            </button>
                        </div>

                        <!-- Móvil: una sola tarjeta con 3 columnas divididas (Editar / Compartir / Ver como visitante) -->
                        <div class="academy-mobile-only mt-4 rounded-2xl border border-gray-100 box-cards overflow-hidden">
                            <div class="academy-profile-actions-mobile">
                                <button [routerLink]="['/account', 'profile']">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-pencil w-4 h-4">
                                        <path
                                            d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                        </path>
                                        <path d="m15 5 4 4"></path>
                                    </svg>
                                    {{ "words.profile-edit" | translate }}
                                </button>
                                <button type="button" aria-label="Compartir" (click)="toggleShare()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-share2 w-4 h-4">
                                        <circle cx="18" cy="5" r="3"></circle>
                                        <circle cx="6" cy="12" r="3"></circle>
                                        <circle cx="18" cy="19" r="3"></circle>
                                        <line x1="8.59" x2="15.42" y1="13.51" y2="17.49"></line>
                                        <line x1="15.41" x2="8.59" y1="6.51" y2="10.49"></line>
                                    </svg>
                                    {{ "words.share" | translate }}
                                </button>
                                <button type="button" (click)="viewAsVisitor()">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-eye w-4 h-4">
                                        <path d="M2.062 12.348a1 1 0 0 1 0-.696 10.75 10.75 0 0 1 19.876 0 1 1 0 0 1 0 .696 10.75 10.75 0 0 1-19.876 0">
                                        </path>
                                        <circle cx="12" cy="12" r="3"></circle>
                                    </svg>
                                    {{ "words.view-as-visitor" | translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Perfil completado (CON LOGICA: profileCompletionPercent — campos reales de /account/profile) -->
                <div class="p-5 rounded-lg bg-white  box-cards">
                    <div *ngIf="profileCompletionPercent >= 100; else profileIncomplete">
                        <div class="flex items-center justify-between">
                            <p class="text-xs font-semibold" style="color: rgb(11, 23, 54);">{{ "words.profile-completed" | translate }}</p>
                            <span class="text-xs font-semibold" style="color: rgb(11, 23, 54);">{{ profileCompletionPercent }}%</span>
                        </div>
                        <div class="mt-2 h-1.5 w-full rounded-full bg-muted">
                            <div class="h-1.5 rounded-full bg-emerald-500" [style.width.%]="profileCompletionPercent"></div>
                        </div>

                        <!-- Perfil completo: botón directo "Actualizar desde CV" (sin acordeón) -->
                        <button type="button" (click)="openImportModal()"
                            class="mt-3 w-full rounded-lg border border-border/60 bg-[#FAFAFA] p-3 text-left flex items-center gap-2 transition hover:bg-[#F2F5F3]">
                            <span class="w-7 h-7 shrink-0 rounded-md flex items-center justify-center" style="background-color: rgb(241, 242, 244);">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-refresh-cw w-4 h-4" style="color: rgb(95, 104, 119);">
                                    <path d="M3 12a9 9 0 0 1 9-9 9.75 9.75 0 0 1 6.74 2.74L21 8"></path>
                                    <path d="M21 3v5h-5"></path>
                                    <path d="M21 12a9 9 0 0 1-9 9 9.75 9.75 0 0 1-6.74-2.74L3 16"></path>
                                    <path d="M8 16H3v5"></path>
                                </svg>
                            </span>
                            <span class="min-w-0 flex-1">
                                <span class="block text-[13px] font-semibold leading-tight" style="color: rgb(11, 23, 54);">{{ "words.update-from-cv" | translate }}</span>
                                <span class="block text-[11px] text-muted-foreground leading-snug mt-0.5">{{ "words.update-from-cv-desc" | translate }}</span>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-right w-4 h-4 shrink-0 text-gray-400">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                    </div>
                    <ng-template #profileIncomplete>
                        <!-- Escritorio: diseño original, sin cambios -->
                        <div class="academy-desktop-only">
                            <div class="flex items-center justify-between">
                                <p class="text-xs font-medium text-gray-700">{{ "words.profile-completed" | translate }}</p>
                                <span class="text-xs font-semibold text-gray-700">{{ profileCompletionPercent }}%</span>
                            </div>
                            <div class="mt-2 h-1.5 w-full rounded-full bg-gray-100">
                                <div class="h-1.5 rounded-full bg-gray-700" [style.width]="profileCompletionPercent + '%'"></div>
                            </div>
                            <p class="mt-1.5 text-[11px] text-gray-500">{{ "words.profile-completed-hint" | translate }}</p>
                        </div>

                        <!-- Móvil: diseño nuevo con colores de marca (progreso en primary, % en secondary) -->
                        <div class="academy-mobile-only">
                            <div class="flex items-center justify-between">
                                <p class="text-sm font-semibold text-gray-800">{{ "words.profile-completed" | translate }}</p>
                                <span class="text-sm font-bold text-gray-700">{{ profileCompletionPercent }}%</span>
                            </div>
                            <div class="mt-2 h-1.5 w-full rounded-full bg-gray-100 overflow-hidden">
                                <div class="h-1.5 rounded-full bg-gray-700 transition-all duration-300" [style.width]="profileCompletionPercent + '%'"></div>
                            </div>
                            <button type="button" [routerLink]="['/account', 'profile']"
                                class="mt-2 w-full flex items-center justify-between gap-2 text-left hover:opacity-80 transition">
                                <p class="text-[11px] text-gray-500">{{ "words.profile-completed-hint" | translate }}</p>
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5 text-primary-500 shrink-0">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>
                    </ng-template>

                    <!-- Toggle "Completar mi perfil" (solo mientras el perfil no esté completo) -->
                    <div *ngIf="profileCompletionPercent < 100">
                        <!-- Escritorio: diseño original, sin cambios -->
                        <div class="academy-desktop-only mt-2 pt-2 border-t border-gray-200 text-left">
                            <button type="button" (click)="toggleOtherWays()"
                                class="inline-flex items-center gap-1 text-xs font-medium transition hover:opacity-80 text-gray-700">
                                {{ "words.complete-my-profile" | translate }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-chevron-down w-3.5 h-3.5 transition-transform"
                                    [class.rotate-180]="showOtherWays">
                                    <path d="m6 9 6 6 6-6"></path>
                                </svg>
                            </button>
                        </div>

                        <!-- Móvil: título + botón circular con tinte primary -->
                        <div class="academy-mobile-only">
                            <div class="mt-4 pt-3 border-t border-gray-100 flex items-center justify-between gap-2">
                                <p class="text-sm font-semibold text-gray-800">{{ "words.complete-my-profile" | translate }}</p>
                                <button type="button" (click)="toggleOtherWays()" [attr.aria-label]="'words.complete-my-profile' | translate"
                                    class="academy-toggle-strengthen-btn shrink-0 w-7 h-7 rounded-full flex items-center justify-center transition hover:opacity-80">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round"
                                        class="lucide lucide-chevron-down w-3.5 h-3.5 transition-transform"
                                        [class.rotate-180]="showOtherWays">
                                        <path d="m6 9 6 6 6-6"></path>
                                    </svg>
                                </button>
                            </div>
                        </div>
                    </div>

                    <!-- Contenido de "Completar mi perfil" -->
                    <div *ngIf="profileCompletionPercent < 100 && showOtherWays" class="mt-2 space-y-2">
                        <button type="button" (click)="openImportModal()"
                            class="academy-import-from-cv-btn w-full flex items-center gap-2 rounded-md px-2 py-2 text-left gk-btn-outline transition">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-file-text w-4 h-4 text-gray-500 shrink-0">
                                <path d="M15 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V7Z"></path>
                                <path d="M14 2v4a2 2 0 0 0 2 2h4"></path>
                                <path d="M16 13H8"></path>
                                <path d="M16 17H8"></path>
                                <path d="M10 9H8"></path>
                            </svg>
                            <span class="min-w-0 flex-1">
                                <p class="text-xs font-semibold text-gray-700">{{ "words.import-from-cv" | translate }}</p>
                                <p class="text-[11px] text-gray-500">{{ "words.import-from-cv-desc" | translate }}</p>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5 text-gray-400 shrink-0">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>

                       

                        <button *ngIf="nextMissingProfileField" type="button"
                            [routerLink]="nextMissingProfileField.action === 'profile' ? ['/account', 'profile'] : null"
                            (click)="handleMissingFieldClick()"
                            class="w-full flex items-center gap-2 rounded-lg px-2 py-2 text-left gk-btn-outline transition">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-circle-check w-4 h-4 text-gray-500 shrink-0">
                                <circle cx="12" cy="12" r="10"></circle>
                                <path d="m9 12 2 2 4-4"></path>
                            </svg>
                            <span class="min-w-0 flex-1">
                                <p class="text-xs font-semibold text-gray-700">{{ nextMissingProfileField.labelKey | translate }}</p>
                            </span>
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5 text-gray-400 shrink-0">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                    </div>

                </div>

                <!-- Menú de secciones (mismo patrón de pestañas que academy-public-page: activeTab / setTab / showSection) -->
                <div class="rounded-lg overflow-hidden bg-white border border-gray-100 box-cards">
                <nav class="p-4 space-y-1">
                    <button type="button" (click)="setTab('resumen')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="isResumen ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-layout-grid w-4 h-4 shrink-0">
                            <rect width="7" height="7" x="3" y="3" rx="1"></rect>
                            <rect width="7" height="7" x="14" y="3" rx="1"></rect>
                            <rect width="7" height="7" x="14" y="14" rx="1"></rect>
                            <rect width="7" height="7" x="3" y="14" rx="1"></rect>
                        </svg>
                        {{ "words.summary" | translate }}
                    </button>
                    <button type="button" (click)="setTab('actividad')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="activeTab === 'actividad' ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-activity w-4 h-4 shrink-0">
                            <path
                                d="M22 12h-2.48a2 2 0 0 0-1.93 1.46l-2.35 8.36a.25.25 0 0 1-.48 0L9.24 2.18a.25.25 0 0 0-.48 0l-2.35 8.36A2 2 0 0 1 4.49 12H2">
                            </path>
                        </svg>
                        {{ "words.academic-activity" | translate }}
                    </button>
                    <button type="button" (click)="setTab('certificados')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="activeTab === 'certificados' ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-award w-4 h-4 shrink-0">
                            <path
                                d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                            </path>
                            <circle cx="12" cy="8" r="6"></circle>
                        </svg>
                        {{ "words.certificates" | translate }}
                    </button>
                    <button *ngIf="grikySkillsEnabled" type="button" (click)="setTab('logros')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="activeTab === 'logros' ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-trophy w-4 h-4 shrink-0">
                            <path d="M6 9H4.5a2.5 2.5 0 0 1 0-5H6"></path>
                            <path d="M18 9h1.5a2.5 2.5 0 0 0 0-5H18"></path>
                            <path d="M4 22h16"></path>
                            <path d="M10 14.66V17c0 .55-.47.98-.97 1.21C7.85 18.75 7 20.24 7 22"></path>
                            <path d="M14 14.66V17c0 .55.47.98.97 1.21C16.15 18.75 17 20.24 17 22"></path>
                            <path d="M18 2H6v7a6 6 0 0 0 12 0V2Z"></path>
                        </svg>
                        {{ "words.achievements" | translate }}
                    </button>
                    <button *ngIf="grikySkillsEnabled" type="button" (click)="setTab('competencias')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="activeTab === 'competencias' ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-radar w-4 h-4 shrink-0">
                            <path d="M19.07 4.93A10 10 0 0 0 6.99 3.34"></path>
                            <path d="M4 6h.01"></path>
                            <path d="M2.29 9.62A10 10 0 1 0 21.31 8.35"></path>
                            <path d="M16.24 7.76A6 6 0 1 0 8.23 16.67"></path>
                            <path d="M12 18h.01"></path>
                            <path d="M17.99 11.66A6 6 0 0 1 15.77 16.67"></path>
                            <circle cx="12" cy="12" r="2"></circle>
                            <path d="m13.41 10.59 5.66-5.66"></path>
                        </svg>
                        {{ "words.my-competencies" | translate }}
                    </button>
                    <button type="button" (click)="setTab('profesional')"
                        class="w-full flex items-center justify-start text-left gap-3 rounded-lg px-3 py-2.5 text-sm transition-colors"
                        [ngClass]="activeTab === 'profesional' ? 'bg-gray-100 font-semibold text-gray-700' : 'text-gray-500 hover:bg-gray-100'">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-user-round w-4 h-4 shrink-0">
                            <circle cx="12" cy="8" r="5"></circle>
                            <path d="M20 21a8 8 0 0 0-16 0"></path>
                        </svg>
                        {{ "words.professional-profile" | translate }}
                    </button>
                </nav>

                <!--OCULTO Completa un curso para obtener tu primer certificado (siempre visible, independiente del estado del perfil) -->
                <div class="hidden px-3 pb-4">
                    <div class="relative overflow-hidden rounded-lg p-5"
                        style="background: linear-gradient(135deg, rgb(11, 23, 54) 0%, rgb(22, 38, 79) 100%);">
                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                            stroke="currentColor" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"
                            class="lucide lucide-graduation-cap absolute -right-4 -bottom-3 w-24 h-24 text-white/10">
                            <path
                                d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                            </path>
                            <path d="M22 10v6"></path>
                            <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                        </svg>
                        <p class="relative text-sm font-semibold leading-snug text-white">{{
                            "words.complete-course-first-certificate" | translate }}</p>
                        <button [routerLink]="['/learn', company?.slug, 'catalogue', 'all']"
                            class="relative mt-4 w-full rounded-full bg-white px-3 py-2 text-xs font-semibold text-gray-700 transition hover:bg-white/90">
                            {{ "words.explore-courses" | translate }}
                        </button>
                    </div>
                </div>
                </div>

                </div>

            </aside>

            <!-- ===================== CONTENIDO PRINCIPAL ===================== -->
            <section class="academy-main-content space-y-6 min-w-0">

                <div *ngIf="isResumen" class=" items-center gap-3 hidden md:flex">
                    <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-gray-400 shrink-0">{{
                        "words.learning-in-progress" | translate }}</p>
                    <span class="flex-1 h-px bg-gray-100"></span>
                </div>

                <!-- Hero skeleton -->
                <div *ngIf="isResumen && isLoadingRV"
                    class="box-cards rounded-md border border-gray-100 bg-white p-6 md:p-7 pointer-events-none animate-pulse">
                    <div class="skeleton-text h-5 w-28 rounded-full"></div>
                    <div class="skeleton-text h-7 w-2/3 rounded mt-4"></div>
                    <div class="skeleton-text h-3 w-20 rounded mt-2"></div>
                    <div class="mt-6 flex items-center gap-4 flex-wrap">
                        <div class="flex-1 min-w-[240px] space-y-2">
                            <div class="skeleton-text h-3 w-32 rounded"></div>
                            <div class="flex items-center gap-4">
                                <div class="skeleton-text h-3 w-24 rounded"></div>
                                <div class="skeleton-text h-3 w-20 rounded"></div>
                            </div>
                        </div>
                        <div class="flex items-center gap-3 shrink-0">
                            <div class="skeleton-text h-10 w-32 rounded-full"></div>
                            <div class="skeleton-text h-10 w-32 rounded-full"></div>
                        </div>
                    </div>
                </div>

                <!-- Hero: Curso en progreso (CON LOGICA: lastViewedCourse — último curso/ruta visto) -->
                <div *ngIf="isResumen && !isLoadingRV" class="academy-hero-banner box-cards  relative md:rounded-xl overflow-hidden p-6 md:p-7"
                    style="background-color: #0a192f; margin-top: 1rem !important;">
                    <img src="assets/images/perfil-hero-bg.png" alt="" aria-hidden="true"
                        class="absolute inset-0 w-full h-full object-cover opacity-90 pointer-events-none">
                    <!-- Imagen del curso visto (lado derecho) con máscara de desvanecido -->
                    <img *ngIf="lastViewedCourse?.image" [src]="lastViewedCourse.image"
                        (error)="onImageError($event, lastViewedCourse)" alt="" aria-hidden="true"
                        class="absolute top-0 right-0 h-full w-1/2 object-cover opacity-60 pointer-events-none"
                        style="mask-image: linear-gradient(to right, transparent 0%, black 60%); -webkit-mask-image: linear-gradient(to right, transparent 0%, black 60%);">
                    <!-- Overlay azul (#0a192f) -->
                    <div class="absolute inset-0 pointer-events-none"
                        style="background: linear-gradient(90deg, #0a192f 0%, #0a192f 40%, rgba(10, 25, 47, 0.55) 80%, rgba(10, 25, 47, 0.35) 100%);">
                    </div>
                    <!-- Empty state: sin curso en marcha (no hay curso en progreso) -->
                    <div *ngIf="!lastViewedCourse" class="relative flex flex-col items-center text-center py-4">
                        <h1 class="text-2xl md:text-2xl font-bold text-white tracking-tight">{{ "words.no-active-course" |
                            translate }}</h1>
                        <p class="mt-2 text-sm font-medium text-white/70 max-w-md">{{ "words.choose-enrolled-course" |
                            translate }}</p>
                        <button [routerLink]="['/learn', company?.slug, 'contents']"
                            class="mt-5 inline-flex items-center gap-2 bg-white text-gray-700 px-5 py-2.5 rounded-full text-sm font-semibold hover:opacity-90">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-play w-3.5 h-3.5 fill-current">
                                <polygon points="6 3 20 12 6 21 6 3"></polygon>
                            </svg>
                            {{ "words.see-my-courses" | translate }}
                        </button>
                    </div>

                    <div *ngIf="lastViewedCourse" class="relative">
                        <span
                            class="inline-block text-[10px] font-bold uppercase tracking-wider text-white/80 bg-white/10 border border-white/20 backdrop-blur-sm rounded-full px-3 py-1">{{
                            "words.recently-enrolled" | translate }}</span>
                        <h1 class="mt-3 text-2xl md:text-2xl font-bold text-white tracking-tight">{{
                            lastViewedCourse?.title || ('words.course-name' | translate) }}</h1>
                        <p class="mt-1 text-xs font-medium text-white/70">{{
                            getContentTypeKey(lastViewedCourse) | translate }}</p>

                        <!-- Curso sin comenzar: fila de proveedor/tipo + dos botones (Ver programa / Comenzar) -->
                        <div *ngIf="(lastViewedCourse?.progress || 0) === 0"
                            class="academy-hero-banner__row mt-6 flex items-start justify-between gap-4 flex-wrap">
                            <div class="flex flex-col gap-2">
                                <span class="text-xs font-medium text-white/60">{{ "words.not-started-course" | translate }}</span>
                                <div class="flex items-center gap-4 flex-wrap">
                                    <span class="inline-flex items-center gap-1.5 text-xs text-white/80">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-building-2 w-3.5 h-3.5">
                                            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                                            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                                            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                                            <path d="M10 6h4"></path>
                                            <path d="M10 10h4"></path>
                                            <path d="M10 14h4"></path>
                                            <path d="M10 18h4"></path>
                                        </svg>
                                        {{ lastViewedCourse?.providerName }}
                                    </span>
                                    <span *ngIf="lastViewedCourse?.isExternal" class="inline-flex items-center gap-1.5 text-xs text-white/80">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-tag w-3.5 h-3.5">
                                            <path
                                                d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z">
                                            </path>
                                            <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
                                        </svg>
                                        {{ "words.external-content" | translate }}
                                    </span>
                                </div>
                            </div>
                            <div class="academy-hero-banner__actions flex items-center gap-3 shrink-0">
                                <button [routerLink]="buildRouterLink(lastViewedCourse?.urlDetail || '')"
                                    class="academy-hero-banner__secondary-btn inline-flex items-center justify-center gap-2 border border-white/40 text-white px-5 py-2.5 rounded-full text-sm font-semibold hover:bg-white/10">
                                    {{ "words.see-program" | translate }}
                                </button>
                                <button [routerLink]="buildRouterLink(lastViewedCourse?.urlDetail || '')"
                                    class="academy-hero-banner__primary-btn inline-flex items-center justify-center gap-2 bg-white text-gray-700 px-5 py-2.5 rounded-full text-sm font-semibold hover:opacity-90">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-play w-3.5 h-3.5 fill-current">
                                        <polygon points="6 3 20 12 6 21 6 3"></polygon>
                                    </svg>
                                    {{ "words.start" | translate }}
                                </button>
                            </div>
                        </div>

                        <!-- Curso en progreso: barra de progreso + Continuar -->
                        <div *ngIf="(lastViewedCourse?.progress || 0) > 0" class="mt-6 flex items-center gap-4 flex-wrap">
                            <div class="flex-1 min-w-[240px]">
                                <!-- Estado: sin comenzar o con progreso -->
                                <p class="text-xs font-medium text-white/60 mb-1">
                                    <ng-container *ngIf="(lastViewedCourse?.progress || 0) > 0">
                                        {{ 'words.you-have-progress' | translate:{ percent: lastViewedCourse.progress } }} {{ 'words.course-completed' | translate }}
                                    </ng-container>
                                    <ng-container *ngIf="(lastViewedCourse?.progress || 0) === 0">
                                        {{ 'words.not-started-yet' | translate }}
                                    </ng-container>
                                </p>
                                <!-- Datos: proveedor + tipo de contenido -->
                                <div class="flex items-center gap-4 text-xs text-white/90">
                                    <span *ngIf="lastViewedCourse?.providerName" class="inline-flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-building-2 w-4 h-4 shrink-0">
                                            <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                                            <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                                            <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                                            <path d="M10 6h4"></path>
                                            <path d="M10 10h4"></path>
                                            <path d="M10 14h4"></path>
                                        </svg>
                                        {{ lastViewedCourse.providerName }}
                                    </span>
                                    <span *ngIf="lastViewedCourse?.typeLabelKey" class="inline-flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-tag w-4 h-4 shrink-0">
                                            <path d="M12.586 2.586A2 2 0 0 0 11.172 2H4a2 2 0 0 0-2 2v7.172a2 2 0 0 0 .586 1.414l8.704 8.704a2.426 2.426 0 0 0 3.42 0l6.58-6.58a2.426 2.426 0 0 0 0-3.42z"></path>
                                            <circle cx="7.5" cy="7.5" r=".5" fill="currentColor"></circle>
                                        </svg>
                                        {{ lastViewedCourse.typeLabelKey | translate }}
                                    </span>
                                </div>
                            </div>
                            <div class="flex items-center gap-3 shrink-0">
                                <!-- Ver programa: outline, lleva a la descripción del curso -->
                                <button [routerLink]="buildRouterLink(lastViewedCourse?.urlDetail || '')"
                                    class="inline-flex items-center gap-2 border-[3px] border-double border-white/70 text-white px-4 py-2 rounded-full text-sm font-semibold hover:bg-white/10 transition-colors">
                                    {{ 'words.see-program' | translate }}
                                </button>
                                <!-- Comenzar / Continuar: sólido, lleva directo al curso -->
                                <button [routerLink]="buildRouterLink(lastViewedCourse?.urlDetail || '')"
                                    class="inline-flex items-center gap-2 bg-white text-gray-800 px-5 py-2.5 rounded-full text-sm font-semibold hover:opacity-90">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-play w-3.5 h-3.5 fill-current">
                                        <polygon points="6 3 20 12 6 21 6 3"></polygon>
                                    </svg>
                                    {{ ((lastViewedCourse?.progress || 0) > 0 ? 'words.continue' : 'words.start') |
                                    translate }}
                                </button>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Fila de estadísticas skeleton -->
                <div *ngIf="isResumen && isLoadingProfile"
                    class="bg-white rounded-lg border border-gray-100 box-cards p-5 pointer-events-none animate-pulse">
                    <div class="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-5 divide-y sm:divide-y-0 lg:divide-y-0 sm:divide-x divide-gray-100">
                        <div *ngFor="let s of [1,2,3,4,5]" class="px-4 py-2 text-center">
                            <div class="skeleton-text h-6 w-10 rounded mx-auto"></div>
                            <div class="skeleton-text h-2.5 w-16 rounded mx-auto mt-2"></div>
                        </div>
                    </div>
                </div>

                <!-- Fila de estadísticas (CON LOGICA: courseStats / achievementsData / totalDedicatedHours) -->
                <div *ngIf="isResumen && !isLoadingProfile" class="rounded-lg bg-white border border-gray-100 box-cards p-5 py-5">
                    <div class="grid grid-cols-1">
                        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 divide-y sm:divide-y-0 divide-x-0 sm:divide-x divide-gray-100">
                            <div class="px-4 py-2 sm:py-0" [title]="'words.stats-active-tooltip' | translate">
                                <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-400">{{
                                    "words.stats-content-active" | translate }}</p>
                                <p class="mt-1.5 leading-none">
                                    <span *ngIf="hasActiveContent; else noActiveContent"
                                        class="text-xl font-bold tracking-tight text-gray-700">{{ activeContentsCount }}</span>
                                    <ng-template #noActiveContent>
                                        <span class="text-xl font-bold tracking-tight text-gray-400">—</span>
                                    </ng-template>
                                </p>
                                <p *ngIf="hasActiveContent; else exploreCatalogue" class="mt-1.5 text-[12.5px] text-[#5F6478]">
                                    <ng-container *ngIf="grikySkillsEnabled; else contentDetailSimple">{{ activeContentBreakdownText }}</ng-container>
                                    <ng-template #contentDetailSimple>{{ statusCounts.completed }} {{ "words.metric-completed-of-prefix" | translate }} {{ statusCounts.total }} {{ "words.metric-enrolled-suffix" | translate }}</ng-template>
                                </p>
                                <ng-template #exploreCatalogue>
                                    <button type="button" [routerLink]="['/learn', company?.slug, 'catalogue', 'all']"
                                        class="mt-1.5 text-xs font-semibold text-primary hover:opacity-80 transition">{{
                                        "words.explore-catalogue" | translate }}</button>
                                </ng-template>
                            </div>
                            <div class="px-4 py-2 sm:py-0" [title]="'words.stats-progress-tooltip' | translate">
                                <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-400">{{
                                    "words.global-progress" | translate }}</p>
                                <p class="mt-1.5 leading-none">
                                    <span class="text-xl font-bold tracking-tight text-gray-700">{{ weightedProgressPercent }}</span>
                                    <span class="pl-1 text-sm font-semibold text-gray-400">%</span>
                                </p>
                                <p class="mt-1.5 text-[12.5px] text-[#5F6478]">{{
                                    "words.stats-progress-detail" | translate }}</p>
                            </div>
                            <div class="px-4 py-2 sm:py-0" [title]="'words.stats-time-tooltip' | translate">
                                <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-400">{{
                                    "words.stats-time-dedicated" | translate }}</p>
                                <p class="mt-1.5 leading-none">
                                    <ng-container *ngIf="totalDedicatedHours > 0; else noDedicatedTime">
                                        <span class="text-xl font-bold tracking-tight text-gray-700">{{ totalDedicatedHours }}</span>
                                        <span class="pl-1 text-sm font-semibold text-gray-400">h</span>
                                    </ng-container>
                                    <ng-template #noDedicatedTime>
                                        <span class="text-xl font-bold tracking-tight text-gray-400">—</span>
                                    </ng-template>
                                </p>
                                <p class="mt-1.5 text-[12.5px]" [ngClass]="totalDedicatedHours > 0 ? 'text-[#5F6478]' : 'text-gray-400'">{{
                                    (totalDedicatedHours > 0 ? "words.stats-time-detail" : "words.stats-time-empty") | translate }}</p>
                            </div>
                            <div *ngIf="!grikySkillsEnabled" class="px-4 py-2 sm:py-0" [title]="'words.certificates' | translate">
                                <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-400">{{ "words.certificates" | translate }}</p>
                                <p class="mt-1.5 leading-none">
                                    <span class="text-xl font-bold tracking-tight text-gray-700">{{ certificates.length }}</span>
                                </p>
                                <p class="mt-1.5 text-[12.5px] text-[#5F6478] truncate"
                                    [title]="nearestActiveContentName ? (('words.metric-next-certificate-prefix' | translate) + ' ' + nearestActiveContentName) : null">
                                    <ng-container *ngIf="nearestActiveContentName; else noCertHintAcademy">{{ "words.metric-next-certificate-prefix" | translate }} <span class="font-medium text-[#232B4D]">{{ nearestActiveContentName }}</span></ng-container>
                                    <ng-template #noCertHintAcademy>{{ "words.metric-no-certificate-hint" | translate }}</ng-template>
                                </p>
                            </div>
                            <div *ngIf="grikySkillsEnabled" class="px-4 py-2 sm:py-0 border-t sm:border-t-0 sm:border-l border-gray-100 sm:pl-4 pt-3 sm:pt-0">
                                <p class="text-[10px] font-semibold uppercase tracking-[0.16em] text-gray-400">{{ "words.stats-level-xp" | translate }}</p>
                                <p class="mt-1.5 leading-none">
                                    <span class="text-xl font-bold tracking-tight text-gray-700">{{ userLevel || 1 }}</span>
                                    <span class="text-xs font-semibold text-gray-400"> · {{ achievementsData?.xp || 0 }} {{ "words.xp" | translate }}</span>
                                </p>
                                <p class="mt-1.5 text-[12.5px] text-[#5F6478]">
                                    <ng-container *ngIf="xpForNextLevel !== null; else maxLevelReached">{{ "words.stats-xp-next-level-prefix" | translate }} {{ xpForNextLevel }} {{ "words.stats-xp-next-level-middle" | translate }} {{ nextLevelNumber }}</ng-container>
                                    <ng-template #maxLevelReached>{{ "words.stats-max-level" | translate }}</ng-template>
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- Continúa donde lo dejaste skeleton -->
                <div *ngIf="isResumen && isLoadingRV"
                    class="bg-white rounded-lg border border-gray-100 box-cards p-5 pointer-events-none animate-pulse">
                    <div class="skeleton-text h-4 w-1/2 rounded mb-4"></div>
                    <div class="grid grid-cols-1 sm:grid-cols-3 gap-4">
                        <div *ngFor="let s of [1,2,3]"
                            class="rounded-lg border border-gray-100 p-4 space-y-3">
                            <div class="skeleton-avatar w-full h-24 rounded-lg"></div>
                            <div class="skeleton-text h-3 w-3/4 rounded"></div>
                            <div class="skeleton-text h-2 w-full rounded-full"></div>
                        </div>
                    </div>
                </div>

                <!-- Continúa donde lo dejaste (CON LOGICA: continueLearningCourses) -->
                <section *ngIf="isResumen && !isLoadingRV">
                    <div class="flex items-center justify-between mb-3">
                        <div class="flex items-baseline gap-2">
                            <h3 class="text-base font-semibold tracking-tight text-gray-700">{{ (continueLearningCourses.length > 0 ?
                                'words.continue-where-you-left-off' : 'words.suggested-for-you') | translate }}</h3>
                        </div>
                        <button *ngIf="continueLearningCourses.length > 0"
                            [routerLink]="['/learn', company?.slug, 'contents']"
                            class="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-500">
                            {{ "words.see-all" | translate }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                    </div>

                    <div *ngIf="continueLearningCourses.length > 0"
                        class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                        <article *ngFor="let course of continueLearningCourses | slice:0:3"
                            class="rounded-lg md: border md:border-border/60 shadow-sm  bg-white p-4 flex flex-col transition-shadow hover:shadow-md">
                            <div class="flex items-start gap-3">
                                <img [src]="course.image" (error)="onImageError($event, course)" [alt]="course.title"
                                    class="h-14 w-16 shrink-0 rounded-md object-cover">
                                <div class="min-w-0">
                                    <p class="text-sm font-bold text-gray-700 leading-snug line-clamp-2 cursor-pointer"
                                        [routerLink]="buildRouterLink(course.urlDetail)">{{
                                        course.title }}</p>
                                    <p class="mt-1 text-[11px] text-gray-500">{{ course.providerName }}</p>
                                </div>
                            </div>
                            <div class="mt-2 flex items-center gap-3">
                                <div class="h-1.5 flex-1 rounded-full bg-gray-100">
                                    <div class="h-1.5 rounded-full bg-progress-gradient"
                                        [style.width]="(course.progress || 0) + '%'"></div>
                                </div>
                                <span class="text-[11px] font-semibold text-gray-500">{{
                                    course.progress || 0 }}%</span>
                                <button [routerLink]="buildRouterLink(course.urlDetail)"
                                    [attr.aria-label]="('words.continue' | translate) + ' ' + course.title"
                                    class="grid h-7 w-7 shrink-0 place-items-center rounded-full bg-primary text-white transition hover:opacity-90">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-play h-3 w-3 fill-current">
                                        <polygon points="6 3 20 12 6 21 6 3"></polygon>
                                    </svg>
                                </button>
                            </div>
                        </article>
                    </div>

                    <!-- Sin cursos en progreso: bloque "Sugeridos para ti" -->
                    <div *ngIf="continueLearningCourses.length === 0" class="bg-white rounded-lg border border-gray-100 box-cards p-5">
                        <p class="text-sm text-gray-500">{{ "words.suggested-replaces-continue" | translate }}</p>
                    </div>
                </section>

                <div *ngIf="isResumen" class="flex items-center gap-3 pt-2 m-4 md:mx-0">
                    <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-gray-400 shrink-0">{{ "words.your-activity" | translate }}</p>
                    <span class="flex-1 h-px bg-gray-100"></span>
                </div>

                      <!-- ===== Actividad Académica (CON LOGICA: filteredContents / filtros / búsqueda / paginación) ===== -->
                <!-- Skeleton -->
                <div *ngIf="showSection('actividad') && isLoading"
                    class="bg-white rounded-lg border border-gray-100 box-cards p-5 pointer-events-none animate-pulse">
                    <div class="flex items-center justify-between mb-4">
                        <div class="skeleton-text h-4 w-1/4 rounded"></div>
                        <div class="skeleton-text h-8 w-72 rounded"></div>
                    </div>
                    <div class="space-y-3">
                        <div *ngFor="let skeleton of skeletonItems" class="flex items-center gap-3">
                            <div class="skeleton-avatar w-10 h-10 rounded-md"></div>
                            <div class="skeleton-text h-4 w-1/2 rounded"></div>
                        </div>
                    </div>
                </div>
                <!-- Contenido -->
                <div *ngIf="showSection('actividad') && !isLoading" class="academic-activity-block">
                    <div class="mb-3 flex items-baseline gap-2 m-4 md:mx-0">
                        <h3 class="text-base font-semibold text-gray-700">{{ "words.academic-activity" | translate }}</h3>
                     
                    </div>
                    <div class="bg-white rounded-lg border border-gray-100 box-cards p-5">
                    <div class="flex items-center justify-between mb-2 gap-3 flex-wrap">
                            <!-- Filtros (CON LOGICA: setStatusFilter / statusFilter / statusCounts) -->
                            <div class="mb-4 academy-profile-tabs inline-flex flex-wrap items-center gap-0.5 border border-gray-200 rounded-full gk-pill-container p-1 w-full md:w-auto">
                                <button (click)="setStatusFilter('all')" type="button"
                                    class="px-4 py-1.5 rounded-full text-xs font-medium transition-colors"
                                    [ngClass]="statusFilter === 'all' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                                    {{ "words.enrolled-chip" | translate }} {{ statusCounts.total }}
                                </button>
                                <button (click)="setStatusFilter('in-progress')" type="button"
                                    class="px-4 py-1.5 rounded-full text-xs font-medium transition-colors"
                                    [ngClass]="statusFilter === 'in-progress' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                                    {{ "words.in-progress" | translate }} {{ statusCounts.inProgress }}
                                </button>
                                <button (click)="setStatusFilter('completed')" type="button"
                                    class="px-4 py-1.5 rounded-full text-xs font-medium transition-colors"
                                    [ngClass]="statusFilter === 'completed' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                                    {{ "words.completed-chip" | translate }} {{ statusCounts.completed }}
                                </button>
                                <button (click)="setStatusFilter('not-started')" type="button"
                                    class="px-4 py-1.5 rounded-full text-xs font-medium transition-colors"
                                    [ngClass]="statusFilter === 'not-started' ? 'bg-white text-gray-900 shadow-sm' : 'text-gray-500 hover:text-gray-700'">
                                    {{ "words.not-started-chip" | translate }} {{ statusCounts.notStarted }}
                                </button>
                            </div>
                            <!-- Búsqueda (CON LOGICA: searchQuery / getContent) -->
                            <div class="relative w-full md:w-auto">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round"
                                    class="lucide lucide-search w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-gray-500">
                                    <circle cx="11" cy="11" r="8"></circle>
                                    <path d="m21 21-4.3-4.3"></path>
                                </svg>
                                <input [placeholder]="'words.search' | translate" [(ngModel)]="searchQuery"
                                    name="search" (ngModelChange)="onSearchChange($event)"
                                    class="pl-9 pr-3 py-1.5 rounded-full border border-gray-200 box-cards bg-white text-sm w-full md:w-44 focus:outline-none focus:ring-1 focus:ring-gray-300">
                            </div>
                    </div>

                    <!-- Tabla (escritorio) -->
                    <div class="overflow-x-auto hidden md:block">
                        <table class="w-full text-sm table-fixed">
                            <thead>
                                <tr class="text-[11px] uppercase tracking-wider text-gray-500 border-b border-gray-200">
                                    <th class="text-left font-medium px-3 py-2.5 w-[28rem]">{{ "words.firstname" | translate
                                        }}
                                    </th>
                                    <th class="text-left font-medium px-3 py-2.5">{{ "words.platform" | translate }}
                                    </th>
                                    <th class="text-left font-medium px-3 py-2.5">{{ "words.state" | translate }}
                                    </th>
                                    <th class="text-left font-medium px-3 py-2.5">{{ "words.progress-label" |
                                        translate
                                        }}</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr *ngFor="let course of filteredContents"
                                    [routerLink]="buildRouterLink(course.data.urlDetail)"
                                    class="border-b border-gray-100 last:border-0 cursor-pointer hover:bg-gray-50 transition">
                                    <td class="px-3 py-3 w-[28rem] max-w-[28rem]">
                                        <div class="flex items-center gap-3 min-w-0">
                                            <img [src]="getContentPicture(course)"
                                                (error)="onImageError($event, course)" [alt]="course.data.title"
                                                class="w-10 h-10 rounded-md object-cover shrink-0">
                                            <p class="text-sm font-medium text-gray-700 truncate" [title]="course.data.title">{{ course.data.title }}</p>
                                        </div>
                                    </td>
                                    <td class="px-3 py-3 text-xs text-gray-500">{{ course.data.provider?.name ??
                                        company.name }}</td>
                                    <td class="px-3 py-3">
                                        <span *ngIf="(course.data.progress || 0) === 0"
                                            class="inline-block px-3 py-1 rounded-full bg-gray-100 text-gray-500 text-xs font-medium">{{
                                            "words.not-started-status" | translate }}</span>
                                        <span
                                            *ngIf="(course.data.progress || 0) > 0 && (course.data.progress || 0) < 100"
                                            class="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">{{
                                            "words.in-progress" | translate }}</span>
                                        <span *ngIf="(course.data.progress || 0) >= 100"
                                            class="inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-medium">{{
                                            "words.completed" | translate }}</span>
                                    </td>
                                    <td class="px-3 py-3">
                                        <div class="flex items-center gap-2 justify-end min-w-[140px]">
                                            <div
                                                class="flex-1 max-w-[100px] h-1.5 rounded-full bg-gray-100 overflow-hidden">
                                                <div class="h-full"
                                                    [ngClass]="(course.data.progress || 0) >= 100 ? 'bg-emerald-500' : ((course.data.progress || 0) > 0 ? 'bg-blue-500' : 'bg-gray-300')"
                                                    [style.width]="(course.data.progress || 0) + '%'"></div>
                                            </div>
                                            <span class="text-xs font-semibold text-gray-700 w-8 text-right">{{
                                                course.data.progress || 0 }}%</span>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>

                    <!-- Lista (móvil) -->
                    <div class="md:hidden space-y-3">
                        <div *ngFor="let course of filteredContents"
                            [routerLink]="buildRouterLink(course.data.urlDetail)"
                            class="rounded-lg border border-gray-100 box-cards p-3 cursor-pointer hover:bg-gray-50 transition">
                            <!-- Título + imagen -->
                            <div class="flex items-start gap-3">
                                <img [src]="getContentPicture(course)" (error)="onImageError($event, course)"
                                    [alt]="course.data.title"
                                    class="w-10 h-10 rounded-md object-cover shrink-0">
                                <p class="text-sm font-medium text-gray-700 leading-snug min-w-0 flex-1">{{
                                    course.data.title }}</p>
                            </div>

                            <!-- Datos -->
                            <div class="mt-3 flex flex-wrap items-center gap-x-4 gap-y-2">
                                <div class="flex items-center gap-1.5">
                                    <span class="text-[11px] uppercase tracking-wider text-gray-400">{{
                                        "words.platform" | translate }}:</span>
                                    <span class="text-xs text-gray-600">{{ course.data.provider?.name ?? company.name
                                        }}</span>
                                </div>
                                <span *ngIf="(course.data.progress || 0) === 0"
                                    class="inline-block px-3 py-1 rounded-full bg-gray-100 text-gray-500 text-xs font-medium">{{
                                    "words.not-started-status" | translate }}</span>
                                <span *ngIf="(course.data.progress || 0) > 0 && (course.data.progress || 0) < 100"
                                    class="inline-block px-3 py-1 rounded-full bg-blue-100 text-blue-700 text-xs font-medium">{{
                                    "words.in-progress" | translate }}</span>
                                <span *ngIf="(course.data.progress || 0) >= 100"
                                    class="inline-block px-3 py-1 rounded-full bg-emerald-100 text-emerald-700 text-xs font-medium">{{
                                    "words.completed" | translate }}</span>
                            </div>

                            <!-- Progreso -->
                            <div class="mt-3 flex items-center gap-2">
                                <div class="flex-1 h-1.5 rounded-full bg-gray-100 overflow-hidden">
                                    <div class="h-full"
                                        [ngClass]="(course.data.progress || 0) >= 100 ? 'bg-emerald-500' : ((course.data.progress || 0) > 0 ? 'bg-blue-500' : 'bg-gray-300')"
                                        [style.width]="(course.data.progress || 0) + '%'"></div>
                                </div>
                                <span class="text-xs font-semibold text-gray-700 w-8 text-right shrink-0">{{
                                    course.data.progress || 0 }}%</span>
                            </div>
                        </div>
                    </div>

                    <!-- Footer + Paginación client-side (CON LOGICA: currentPage / totalPages / goToPage) -->
                    <div class="flex items-center justify-between mt-4">
                        <p class="text-xs text-gray-500">{{ "words.showing-courses" | translate:{ shown:
                            filteredContents.length, total: filteredAll.length } }}</p>
                        <div class="flex items-center gap-1" *ngIf="totalPages > 1">
                            <button (click)="goToPage(currentPage - 1)" [disabled]="currentPage === 1"
                                class="w-7 h-7 rounded-full border border-gray-200 box-cards flex items-center justify-center hover:bg-gray-100">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-left w-3.5 h-3.5">
                                    <path d="m15 18-6-6 6-6"></path>
                                </svg>
                            </button>
                            <ng-container *ngFor="let item of getPageItems()">
                                <span *ngIf="item === '...'"
                                    class="w-7 h-7 flex items-center justify-center text-xs text-gray-400 select-none">…</span>
                                <button *ngIf="item !== '...'" (click)="goToPage(item)"
                                    class="w-7 h-7 rounded-full text-xs font-medium"
                                    [ngClass]="currentPage === item ? 'bg-gray-800 text-white' : 'text-gray-500 hover:bg-gray-100'">
                                    {{ item }}
                                </button>
                            </ng-container>
                            <button (click)="goToPage(currentPage + 1)" [disabled]="currentPage === totalPages"
                                class="w-7 h-7 rounded-full border border-gray-200 box-cards flex items-center justify-center hover:bg-gray-100">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>
                    </div>
                    </div>
                </div>

                <!-- ===== Últimos certificados (carrusel) ===== -->
                <!-- Skeleton -->
                <div *ngIf="showSection('certificados') && isLoadingProfile"
                    class="bg-white rounded-lg border border-gray-100 box-cards p-6 pointer-events-none animate-pulse mt-4">
                    <div class="skeleton-text h-5 w-56 rounded"></div>
                    <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 mt-6">
                        <div *ngFor="let s of [1,2,3,4]" class="rounded-lg border border-gray-100 overflow-hidden">
                            <div class="aspect-[16/10] bg-gray-100"></div>
                            <div class="p-4 space-y-2">
                                <div class="skeleton-text h-4 w-3/4 rounded"></div>
                                <div class="skeleton-text h-3 w-1/2 rounded"></div>
                            </div>
                        </div>
                    </div>
                </div>

                <!-- CON certificados: diseño nuevo (carrusel en un solo div) -->
                <div *ngIf="showSection('certificados') && !isLoadingProfile && certificates.length > 0">
                    <div class="flex items-start justify-between gap-4 flex-wrap mb-3 mt-4">
                        <div class="flex items-baseline gap-2 flex-wrap">
                            <h3 class="text-base font-semibold text-gray-700 flex items-center gap-1.5">
                                {{ "words.attestations" | translate }}
                            </h3>
                           
                        </div>
                        <a *ngIf="certificates.length > 4"
                            [routerLink]="['/learn', company.slug, 'academy', 'certificates']"
                            class="inline-flex items-center gap-1 text-xs text-gray-500 hover:text-[#FF2D55] transition-colors">+
                            Ver todos</a>
                    </div>
                    <div class=" rounded-lg border border-gray-100 box-cards ">
                    <div class="bg-white rounded-lg border border-gray-100  p-6">

                        <div class="relative mt-0">
                            <!-- Flecha anterior -->
                            <button *ngIf="certTotalPages > 1" (click)="certPrev()" [disabled]="certPage === 0"
                                aria-label="Anterior"
                                class="cert-desktop-only absolute -left-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 shadow-sm items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-40">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-left w-4 h-4 text-[#374151]">
                                    <path d="m15 18-6-6 6-6"></path>
                                </svg>
                            </button>

                            <!-- Slider táctil (móvil): 1 card a la vez, desliza con el dedo -->
                            <div class="cert-mobile-scroll overflow-x-auto snap-x snap-mandatory gap-4 px-1 pb-2">
                                <div *ngFor="let item of allCertItems" class="snap-center shrink-0 w-[68%]">
                                    <ng-container *ngTemplateOutlet="certCard; context: { $implicit: item }"></ng-container>
                                </div>
                            </div>

                            <!-- Grid paginado (escritorio) -->
                            <div class="cert-desktop-grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 gap-4 px-2">
                                <ng-container *ngFor="let item of pagedCertItems">
                                    <ng-container *ngTemplateOutlet="certCard; context: { $implicit: item }"></ng-container>
                                </ng-container>
                            </div>

                            <!-- Flecha siguiente -->
                            <button *ngIf="certTotalPages > 1" (click)="certNext()"
                                [disabled]="certPage === certTotalPages - 1" aria-label="Siguiente"
                                class="cert-desktop-only absolute -right-3 top-1/2 -translate-y-1/2 z-10 w-9 h-9 rounded-full bg-white border border-gray-200 shadow-sm items-center justify-center hover:bg-gray-100 transition-colors disabled:opacity-40">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-right w-4 h-4 text-[#374151]">
                                    <path d="m9 18 6-6-6-6"></path>
                                </svg>
                            </button>
                        </div>

                        <!-- Dots (escritorio) -->
                        <div *ngIf="certTotalPages > 1" class="cert-desktop-only items-center justify-center gap-1.5 mt-5">
                            <span *ngFor="let p of [].constructor(certTotalPages); let i = index"
                                (click)="goCertPage(i)" class="h-1.5 rounded-full cursor-pointer transition-all"
                                [ngClass]="certPage === i ? 'w-6 bg-[#374151]' : 'w-1.5 bg-gray-200'"></span>
                        </div>

                        <!-- ===== Plantilla de card de certificado (reutilizada en móvil y escritorio) ===== -->
                        <ng-template #certCard let-item>
                                    <!-- Card certificado -->
                                    <article *ngIf="!item.learnMore" (click)="openCertModal(item)"
                                        class="group relative rounded-lg bg-white border border-gray-200 p-3 flex flex-col items-center text-center transition-all hover:-translate-y-1 hover:shadow-[0_20px_50px_-20px_rgba(11,23,54,0.15)] cursor-pointer">
                                        <!-- Logo del proveedor -->
                                        <div
                                            class="relative w-11 h-11 rounded-full bg-gray-50 border border-gray-200 flex items-center justify-center overflow-hidden">
                                            <img [src]="item.providerLogo" (error)="onLogoError($event, item)"
                                                [alt]="item.providerName" class="w-6 h-6 object-contain">
                                        </div>
                                        <!-- Insignia verificado -->
                                        <svg viewBox="0 0 24 24" class="absolute top-2.5 right-2.5 w-4 h-4"
                                            xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
                                            <path d="M12 1.6l8.5 4.9v11L12 22.4 3.5 17.5v-11L12 1.6z" fill="#7c3aed"
                                                stroke="#7c3aed" stroke-width="1" stroke-linejoin="round"></path>
                                            <path d="M8.2 12.2l2.8 2.8 5-5.4" fill="none" stroke="#ffffff"
                                                stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"></path>
                                        </svg>
                                           <h4 class="min-h-[2rem] mt-3 px-2 text-xs font-semibold leading-tight text-gray-700 line-clamp-2">

                                            {{ item.contentName }}</h4>
                                        <p class="text-xs text-[#5F6877] mt-0.5">{{ item.providerName }}</p>
                                        <div class="w-full mt-2 pt-2 border-t border-gray-200">
                                            <p
                                                class="text-[9px] font-semibold uppercase tracking-wider text-[#5F6877]">
                                                Emitido el</p>
                                            <p class="text-[10px] font-semibold mt-0.5 text-gray-700">{{
                                                item.certificatedDate | date:'d MMM, y' }}</p>
                                        </div>
                                    </article>

                                    <!-- Tile: Sigue aprendiendo -->
                                    <article *ngIf="item.learnMore" [routerLink]="['/learn', company.slug, 'contents']"
                                        class="rounded-lg border-2 border-dashed border-gray-200 bg-gray-50 p-5 flex flex-col items-center justify-center text-center hover:border-[#5F6877]/40 hover:bg-gray-100 transition-colors cursor-pointer min-h-[220px]">
                                        <div
                                            class="w-12 h-12 rounded-full bg-white border border-gray-200 flex items-center justify-center mb-3">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                                viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                                stroke-linecap="round" stroke-linejoin="round"
                                                class="lucide lucide-award w-5 h-5 text-[#5F6877]">
                                                <path
                                                    d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                                </path>
                                                <circle cx="12" cy="8" r="6"></circle>
                                            </svg>
                                        </div>
                                        <h4 class="text-sm font-bold text-[#22304C]">{{ "words.keep-learning" | translate
                                            }}</h4>
                                        <p class="text-[11px] text-[#5F6877] mt-1.5 max-w-[180px]">{{
                                            "words.keep-learning-desc" | translate }}</p>
                                    </article>
                        </ng-template>
                    </div>
                    </div>
                </div>


                <!-- SIN certificados: diseño anterior (dos divs: tarjeta vacía + promo catálogos) -->
                <div *ngIf="showSection('certificados') && !isLoadingProfile && certificates.length === 0">
                    <div class="flex items-baseline gap-2 flex-wrap mb-3 mt-4">
                       <h3 class="text-base font-semibold text-gray-700 flex items-center gap-1.5">
                                {{ "words.attestations" | translate }}
                            </h3>

                    </div>
                    <div class="rounded-lg bg-white border border-dashed border-gray-300 p-6 flex flex-col items-center text-center">
                        <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-award w-5 h-5 text-gray-400">
                                <path
                                    d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                </path>
                                <circle cx="12" cy="8" r="6"></circle>
                            </svg>
                        </div>
                        
                        <p class="mt-1 text-xs text-gray-500 max-w-xs">{{ "words.no-certificates-obtained" | translate }}</p>
                        <button *ngIf="allContents.length > 0" type="button" [routerLink]="['/learn', company?.slug, 'contents']"
                            class="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-arrow-right w-3.5 h-3.5">
                                <path d="M5 12h14"></path>
                                <path d="m12 5 7 7-7 7"></path>
                            </svg>
                            {{ "words.see-my-courses" | translate }}
                        </button>
                        <button *ngIf="allContents.length === 0" type="button" [routerLink]="['/learn', company.slug, 'catalogue', 'all']"
                            class="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
                                stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
                                class="lucide lucide-arrow-right w-3.5 h-3.5">
                                <path d="M5 12h14"></path>
                                <path d="m12 5 7 7-7 7"></path>
                            </svg>
                            {{ "words.explore-catalog" | translate }}
                        </button>
                    </div>
                </div>

                <!-- Mis logros skeleton -->
                <div *ngIf="showSection('logros') && grikySkillsEnabled && isLoadingAchievements"
                    class="bg-white rounded-lg border border-gray-100 box-cards p-5 pointer-events-none animate-pulse mt-4">
                    <div class="skeleton-text h-4 w-1/4 rounded mb-4"></div>
                    <div class="grid grid-cols-2 md:grid-cols-4 gap-4">
                        <div *ngFor="let s of [1,2,3,4]" class="rounded-lg border border-gray-100 p-4 space-y-3">
                            <div class="skeleton-avatar w-16 h-16 rounded-full mx-auto"></div>
                            <div class="skeleton-text h-3 w-3/4 rounded mx-auto"></div>
                        </div>
                    </div>
                </div>

                <!-- Mis logros (CON LOGICA: achievementsData) -->
                <div *ngIf="showSection('logros') && grikySkillsEnabled && !isLoadingAchievements && unlockedAchievements.length > 0">
                    <div class="flex items-center justify-between gap-3 mb-2 flex-wrap mb-3 mt-4">
                        <div class="flex items-baseline gap-2 flex-wrap">
                            <h3 class="text-base font-semibold text-gray-700">{{ "words.achievements" | translate }}</h3>
                            <span class="text-xs text-gray-500">{{ achievementsUnlockedCount }} {{ "words.achievements-subtitle-connector" | translate }} {{ achievementsData?.achievements?.length || 0 }} <ng-container *ngIf="nextAchievementName"> · {{ "words.achievements-next-badge-prefix" | translate }} {{ nextAchievementName }}</ng-container></span>
                        </div>
                        <button *ngIf="unlockedAchievements.length > 5"
                            [routerLink]="['/learn', company?.slug, 'griky-skills', 'achievements']"
                            class="inline-flex items-center gap-1.5 text-xs font-semibold text-gray-500">
                            {{ "words.see-all-achievements" | translate }}
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                stroke-linejoin="round" class="lucide lucide-chevron-right w-3.5 h-3.5">
                                <path d="m9 18 6-6-6-6"></path>
                            </svg>
                        </button>
                    </div>
                    <div class="bg-white rounded-lg border border-gray-100 box-cards p-5">
                    <div class="achievements-cards-row gap-3">
                        <div *ngFor="let achievement of unlockedAchievements | slice:0:5"
                            class="achievements-cards-row__item group relative rounded-lg overflow-hidden border border-gray-200 flex flex-col transition-all hover:-translate-y-0.5 hover:shadow-[0_6px_20px_rgba(34,48,76,0.1)]">
                            <img [src]="achievementBadgeUrl(achievement.icon)" [alt]="achievement.name" loading="lazy"
                                class="block w-full aspect-square object-contain">
                            <div class="py-1.5 text-center bg-gray-100">
                                <span class="text-xs font-bold font-mono text-gray-600">+{{ achievement.points }} XP</span>
                            </div>
                        </div>
                    </div>
                    </div>
                </div>

                <div *ngIf="isResumen" class="flex items-center gap-3 pt-2">
                    <p class="text-[11px] font-bold uppercase tracking-[0.14em] text-gray-400 shrink-0">{{ "words.your-profile" | translate }}</p>
                    <span class="flex-1 h-px bg-gray-100"></span>
                </div>

                <div *ngIf="showSection('competencias') && grikySkillsEnabled" class="mt-4">

                    <app-skills-competencies [skills]="acquiredSkills" [objective]="objectiveRole"
                        [estimatedTime]="objectiveTime" [route]="routeSummary"
                        [currentRole]="me?.headline || '—'" [matchPercent]="matchPercent"
                        [missingCompetencies]="missingCompetencies" [allowViewToggle]="true"
                        [companySlug]="company?.slug"></app-skills-competencies>
                </div>

                <!-- ===== Mis Competencias (componente; burbujas con datos reales) ===== -->
                <!-- Habilidades: solo dentro de "Mi perfil profesional" > pestaña Habilidades (ver más abajo) -->

                <!-- ===== Mi perfil profesional (CON LOGICA: me.biography / me.city / me.email / me.phoneNumber + experiences/education/externalCerts) ===== -->
                <div *ngIf="showSection('profesional')">
                    <div class="flex items-start justify-between gap-3 flex-wrap mb-3 mt-4">
                        <h3 class="text-base font-semibold text-gray-700">{{ "words.my-professional-profile" | translate }}</h3>
                    </div>
                    <div class="bg-white rounded-lg border border-gray-100 box-cards p-5">

                    <!-- Pestañas internas: Resumen / Experiencia laboral / Educación / Certificaciones -->
                    <div class=" mb-4 flex items-center gap-6 overflow-x-auto border-b border-gray-200">
                        <button type="button" (click)="setProfileSubTab('resumen')"
                            class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2"
                            [ngClass]="profileSubTab === 'resumen' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                            {{ "words.summary" | translate }}
                        </button>
                        <button type="button" (click)="setProfileSubTab('experience')"
                            class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 inline-flex items-center gap-1.5"
                            [ngClass]="profileSubTab === 'experience' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                            {{ "words.work-experience" | translate }}
                            <span *ngIf="experiences.length" class="rounded-full text-gray-500 text-[12px] font-semibold ">({{ experiences.length }})</span>
                        </button>
                        <button type="button" (click)="setProfileSubTab('education')"
                            class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 inline-flex items-center gap-1.5"
                            [ngClass]="profileSubTab === 'education' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                            {{ "words.education" | translate }}
                            <span *ngIf="education.length" class="rounded-full text-gray-500 text-[12px] font-semibold ">({{ education.length }})</span>
                        </button>
                        <button type="button" (click)="setProfileSubTab('certifications')"
                            class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2 inline-flex items-center gap-1.5"
                            [ngClass]="profileSubTab === 'certifications' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                            {{ "words.external-certifications" | translate }}
                            <span *ngIf="externalCerts.length" class="rounded-full text-gray-500 text-[12px] font-semibold ">({{ externalCerts.length }})</span>
                        </button>
                        <button type="button" (click)="setProfileSubTab('skills')"
                            class="shrink-0 pb-2 text-sm font-medium transition-colors border-b-2"
                            [ngClass]="profileSubTab === 'skills' ? 'text-gray-700 border-primary' : 'text-gray-500 border-transparent hover:text-gray-700'">
                            {{ "words.skills" | translate }}
                        </button>
                    </div>

                    <!-- ===== Habilidades (vista completa dentro de Mi perfil profesional) ===== -->
                    <div *ngIf="profileSubTab === 'skills'">
                        <div *ngIf="acquiredSkills?.length > 0; else noSkillsTab" class="flex flex-wrap gap-2">
                            <span *ngFor="let skill of acquiredSkills"
                                class="rounded-full bg-gray-100 border border-gray-100 px-4 py-2 text-xs font-medium text-gray-700">{{
                                skill.skillName }}</span>
                        </div>
                        <ng-template #noSkillsTab>
                            <p class="text-xs text-gray-400">{{ "words.no-skills-registered" | translate }}</p>
                        </ng-template>
                    </div>

                    <!-- ===== Resumen: Sobre mí + contacto + resumen de las 3 secciones ===== -->
                    <ng-container *ngIf="profileSubTab === 'resumen'">
                        <div class="rounded-lg border border-gray-200 p-4">
                            <!-- Sobre mí -->
                            <div *ngIf="me?.biography">
                                <div class="flex items-center justify-between gap-2">
                                    <p class="text-sm font-semibold text-gray-700">{{ "words.about-me" | translate }}</p>
                                    <button type="button" [routerLink]="['/account', 'profile']"
                                        class="inline-flex items-center gap-1 text-xs font-medium text-gray-400 hover:opacity-80 transition-colors shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5">
                                            <path
                                                d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                            </path>
                                            <path d="m15 5 4 4"></path>
                                        </svg>
                                        {{ "words.edit" | translate }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-arrow-up-right w-3.5 h-3.5">
                                            <path d="M7 7h10v10"></path>
                                            <path d="M7 17 17 7"></path>
                                        </svg>
                                    </button>
                                </div>
                                <p #bioText class="mt-2 text-xs text-gray-500 leading-relaxed max-w-[70ch]"
                                    [style.display]="bioExpanded ? 'block' : '-webkit-box'"
                                    [style.-webkit-line-clamp]="bioExpanded ? 'unset' : '4'"
                                    [style.-webkit-box-orient]="'vertical'"
                                    [style.overflow]="bioExpanded ? 'visible' : 'hidden'">{{ me.biography }}</p>
                                <button *ngIf="bioOverflowing" type="button" (click)="bioExpanded = !bioExpanded"
                                    class="mt-2 text-xs font-medium text-primary hover:underline">
                                    {{ (bioExpanded ? 'words.see-less' : 'words.see-more') | translate }}
                                </button>
                            </div>

                            <div *ngIf="me?.biography" class="my-4 border-t border-gray-100"></div>

                            <!-- Datos de contacto -->
                            <div>
                                <div class="flex items-center justify-between gap-2 mb-3">
                                    <p class="text-sm font-semibold text-gray-700">{{ "words.contact-info" | translate }}</p>
                                    <button type="button" [routerLink]="['/account', 'profile']"
                                        class="inline-flex items-center gap-1 text-xs font-medium text-gray-400 hover:opacity-80 transition-colors shrink-0">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5">
                                            <path
                                                d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                            </path>
                                            <path d="m15 5 4 4"></path>
                                        </svg>
                                        {{ "words.edit" | translate }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-arrow-up-right w-3.5 h-3.5">
                                            <path d="M7 7h10v10"></path>
                                            <path d="M7 17 17 7"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div class="flex flex-wrap items-center gap-x-6 gap-y-2">
                                    <div *ngIf="me?.email" class="flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-mail w-3.5 h-3.5 text-gray-400 shrink-0">
                                            <rect width="20" height="16" x="2" y="4" rx="2"></rect>
                                            <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"></path>
                                        </svg>
                                        <span class="text-xs text-gray-500">{{ me.email }}</span>
                                    </div>
                                    <div *ngIf="me?.phoneNumber" class="flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-phone w-3.5 h-3.5 text-gray-400 shrink-0">
                                            <path
                                                d="M13.832 16.568a1 1 0 0 0 1.213-.303l.355-.465A2 2 0 0 1 17 15h3a2 2 0 0 1 2 2v3a2 2 0 0 1-2 2A18 18 0 0 1 2 4a2 2 0 0 1 2-2h3a2 2 0 0 1 2 2v3a2 2 0 0 1-.883 1.664l-.454.339a1 1 0 0 0-.29 1.257 11 11 0 0 0 6.459 6.26z">
                                            </path>
                                        </svg>
                                        <span class="text-xs text-gray-500">{{ me.phoneNumber }}</span>
                                    </div>
                                    <div *ngIf="me?.city" class="flex items-center gap-1.5">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-map-pin w-3.5 h-3.5 text-gray-400 shrink-0">
                                            <path
                                                d="M20 10c0 4.993-5.539 10.193-7.399 11.799a1 1 0 0 1-1.202 0C9.539 20.193 4 14.993 4 10a8 8 0 0 1 16 0">
                                            </path>
                                            <circle cx="12" cy="10" r="3"></circle>
                                        </svg>
                                        <span class="text-xs text-gray-500">{{ me.city }}</span>
                                    </div>
                                </div>
                            </div>
                        </div>

                        <!-- Resumen de Experiencia laboral / Educación / Certificaciones (3 columnas) -->
                        <div class="grid grid-cols-1 lg:grid-cols-3 gap-4 mt-5">
                            <!-- Experiencia laboral -->
                            <div class="rounded-lg border border-gray-200 p-4">
                                <div class="flex items-center justify-between">
                                    <p class="text-sm font-semibold text-gray-700">{{ "words.work-experience" | translate }}</p>
                                    <button *ngIf="experiences.length" type="button" (click)="setProfileSubTab('experience')"
                                        class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500">
                                        {{ "words.see-all" | translate }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-chevron-right w-3 h-3">
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div *ngIf="experiences.length" class="mt-4 relative">
                                    <div *ngFor="let exp of sortedExperiences | slice:0:3; let last = last"
                                        class="relative flex items-start gap-3" [class.pb-4]="!last">
                                        <span *ngIf="!last" class="absolute left-[13px] top-7 bottom-0 w-px bg-gray-200"
                                            aria-hidden="true"></span>
                                        <span class="relative z-10 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-briefcase w-3.5 h-3.5 text-gray-700">
                                                <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                                <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                                            </svg>
                                        </span>
                                        <div class="min-w-0 flex-1">
                                            <div class="flex items-start justify-between gap-2">
                                                <p class="text-sm font-semibold leading-snug text-gray-700">{{ exp.title }}</p>
                                                <span *ngIf="exp.current"
                                                    class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-600 shrink-0">{{
                                                    "words.current" | translate }}</span>
                                            </div>
                                            <p class="mt-0.5 text-xs text-gray-500">{{ exp.period }}</p>
                                        </div>
                                    </div>
                                </div>
                                <button *ngIf="experiences.length" type="button" (click)="openExperienceModal()"
                                    class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                        <path d="M5 12h14"></path>
                                        <path d="M12 5v14"></path>
                                    </svg>
                                    {{ "words.add-experience" | translate }}
                                </button>
                                <ng-container *ngIf="!experiences.length">
                                    <p class="mt-4 text-xs text-gray-500">{{ "words.add-experience-empty" | translate }}</p>
                                    <button type="button" (click)="openExperienceModal()"
                                        class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5v14"></path>
                                        </svg>
                                        {{ "words.add-experience" | translate }}
                                    </button>
                                </ng-container>
                            </div>

                            <!-- Educación -->
                            <div class="rounded-lg border border-gray-200 p-4">
                                <div class="flex items-center justify-between">
                                    <p class="text-sm font-semibold text-gray-700">{{ "words.education" | translate }}</p>
                                    <button *ngIf="education.length" type="button" (click)="setProfileSubTab('education')"
                                        class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500">
                                        {{ "words.see-all" | translate }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-chevron-right w-3 h-3">
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div *ngIf="education.length" class="mt-4 relative">
                                    <div *ngFor="let edu of sortedEducation | slice:0:3; let last = last"
                                        class="relative flex items-start gap-3" [class.pb-4]="!last">
                                        <span *ngIf="!last" class="absolute left-[13px] top-7 bottom-0 w-px bg-gray-200"
                                            aria-hidden="true"></span>
                                        <span class="relative z-10 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-graduation-cap w-3.5 h-3.5 text-gray-700">
                                                <path
                                                    d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                                </path>
                                                <path d="M22 10v6"></path>
                                                <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                                            </svg>
                                        </span>
                                        <div class="min-w-0">
                                            <p class="text-sm font-semibold text-gray-700">{{ edu.university }}</p>
                                            <p class="mt-0.5 text-xs text-gray-500">{{ edu.career }}</p>
                                            <p class="text-xs text-gray-500">{{ edu.period }}</p>
                                        </div>
                                    </div>
                                </div>
                                <button *ngIf="education.length" type="button" (click)="openEducationModal()"
                                    class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                        <path d="M5 12h14"></path>
                                        <path d="M12 5v14"></path>
                                    </svg>
                                    {{ "words.add-education" | translate }}
                                </button>
                                <ng-container *ngIf="!education.length">
                                    <p class="mt-4 text-xs text-gray-500">{{ "words.add-education-empty" | translate }}</p>
                                    <button type="button" (click)="openEducationModal()"
                                        class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5v14"></path>
                                        </svg>
                                        {{ "words.add-education" | translate }}
                                    </button>
                                </ng-container>
                            </div>

                            <!-- Certificaciones -->
                            <div class="rounded-lg border border-gray-200 p-4">
                                <div class="flex items-center justify-between">
                                    <p class="text-sm font-semibold text-gray-700">{{ "words.external-certifications" | translate }}</p>
                                    <button *ngIf="externalCerts.length" type="button" (click)="setProfileSubTab('certifications')"
                                        class="inline-flex items-center gap-1 text-[11px] font-semibold text-gray-500">
                                        {{ "words.see-all" | translate }}
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-chevron-right w-3 h-3">
                                            <path d="m9 18 6-6-6-6"></path>
                                        </svg>
                                    </button>
                                </div>
                                <div *ngIf="externalCerts.length" class="mt-4 relative">
                                    <div *ngFor="let cert of sortedExternalCerts | slice:0:3; let last = last"
                                        class="relative flex items-start gap-3" [class.pb-4]="!last">
                                        <span *ngIf="!last" class="absolute left-[13px] top-7 bottom-0 w-px bg-gray-200"
                                            aria-hidden="true"></span>
                                        <img *ngIf="cert.logo" [src]="cert.logo" [alt]="cert.org" loading="lazy"
                                            class="relative z-10 w-7 h-7 rounded-lg object-contain shrink-0">
                                        <span *ngIf="!cert.logo"
                                            class="relative z-10 w-7 h-7 rounded-lg bg-gray-100 flex items-center justify-center shrink-0">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-award w-3.5 h-3.5 text-gray-700">
                                                <path
                                                    d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                                </path>
                                                <circle cx="12" cy="8" r="6"></circle>
                                            </svg>
                                        </span>
                                        <div class="min-w-0">
                                            <p class="text-sm font-semibold leading-snug text-gray-700">{{ cert.title }}</p>
                                            <p class="mt-0.5 text-xs text-gray-500">{{ cert.org }} · {{ cert.date }}</p>
                                        </div>
                                    </div>
                                </div>
                                <button *ngIf="externalCerts.length" type="button" (click)="openCertificationModal()"
                                    class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                        <path d="M5 12h14"></path>
                                        <path d="M12 5v14"></path>
                                    </svg>
                                    {{ "words.add-certification" | translate }}
                                </button>
                                <ng-container *ngIf="!externalCerts.length">
                                    <p class="mt-4 text-xs text-gray-500">{{ "words.add-certification-empty" | translate }}</p>
                                    <button type="button" (click)="openCertificationModal()"
                                        class="mt-3 w-full inline-flex items-center justify-center gap-1.5 rounded-full border border-gray-300 bg-white px-3 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                        <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                            fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                            stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                            <path d="M5 12h14"></path>
                                            <path d="M12 5v14"></path>
                                        </svg>
                                        {{ "words.add-certification" | translate }}
                                    </button>
                                </ng-container>
                            </div>
                        </div>
                    </ng-container>

                    <!-- ===== Experiencia laboral (vista completa) ===== -->
                    <div *ngIf="profileSubTab === 'experience'">
                        
                        <div *ngIf="experiences.length" class="space-y-2">
                            <div *ngFor="let exp of sortedExperiences | slice:0:experienceVisibleCount"
                                class="flex items-start gap-3 rounded-lg border border-gray-200 p-3">
                                <span
                                    class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center overflow-hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-briefcase w-5 h-5 text-gray-500">
                                        <path d="M16 20V4a2 2 0 0 0-2-2h-4a2 2 0 0 0-2 2v16"></path>
                                        <rect width="20" height="14" x="2" y="6" rx="2"></rect>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1 flex items-start justify-between gap-2">
                                    <div class="min-w-0">
                                        <p class="text-sm font-semibold leading-tight text-gray-700">{{ exp.title }}</p>
                                        <p class="text-xs text-gray-500 mt-0.5">{{ exp.period }}</p>
                                    </div>
                                    <div class="shrink-0 flex items-center gap-1.5">
                                        <span *ngIf="exp.current"
                                            class="rounded-full bg-emerald-50 px-2 py-0.5 text-[10px] font-semibold text-emerald-600">{{
                                            "words.current" | translate }}</span>
                                        <button type="button" (click)="openExperienceModal(exp)" aria-label="Editar"
                                            class="text-gray-400 hover:text-gray-700 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5">
                                                <path
                                                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                                </path>
                                                <path d="m15 5 4 4"></path>
                                            </svg>
                                        </button>
                                        <button type="button" (click)="deleteExperience(exp)" aria-label="Eliminar"
                                            class="text-gray-400 hover:text-red-600 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-trash-2 w-3.5 h-3.5">
                                                <path d="M3 6h18"></path>
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                                </path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="sortedExperiences.length > experienceVisibleCount" class="mt-3 flex justify-center">
                            <button type="button" (click)="showMoreExperience()"
                                class="inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                {{ "words.see-more" | translate }} {{ sortedExperiences.length - experienceVisibleCount }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                    <path d="m6 9 6 6 6-6"></path>
                                </svg>
                            </button>
                        </div>
                        <div *ngIf="experiences.length" class="my-4 border-t border-gray-100"></div>
                        <button *ngIf="experiences.length" type="button" (click)="openExperienceModal()"
                            class="w-full flex items-center gap-2 text-left group  justify-start">
                            <span class="w-7 h-7 shrink-0 rounded-md border border-dashed border-gray-600 flex items-center justify-center text-gray-700 group-hover:border-gray-400 group-hover:text-gray-600 transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-3.5 h-3.5">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                            </span>
                            <span class="text-sm font-semibold text-gray-700 group-hover:opacity-80 transition">{{ "words.add-experience" | translate }}</span>
                        </button>
                        <!-- Empty state: sin experiencia -->
                        <div *ngIf="!experiences.length"
                            class="rounded-lg border border-dashed border-gray-300 p-6 flex flex-col items-center text-center">
                            <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-building-2 w-5 h-5 text-gray-400">
                                    <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"></path>
                                    <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"></path>
                                    <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"></path>
                                    <path d="M10 6h4"></path>
                                    <path d="M10 10h4"></path>
                                    <path d="M10 14h4"></path>
                                </svg>
                            </div>

                            <p class="mt-1 text-xs text-gray-500 max-w-xs">{{ "words.add-experience-empty" | translate }}</p>
                            <button type="button" (click)="openExperienceModal()"
                                class="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                                {{ "words.add-experience" | translate }}
                            </button>
                        </div>
                    </div>

                    <!-- ===== Educación (vista completa) ===== -->
                    <div *ngIf="profileSubTab === 'education'">
                        
                        <div *ngIf="education.length" class="space-y-2">
                            <div *ngFor="let edu of sortedEducation | slice:0:educationVisibleCount"
                                class="flex items-start gap-3 rounded-lg border border-gray-200 p-3">
                                <span
                                    class="w-10 h-10 shrink-0 rounded-full bg-gray-100 border border-gray-200 flex items-center justify-center overflow-hidden">
                                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                        fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                        stroke-linejoin="round" class="lucide lucide-graduation-cap w-5 h-5 text-gray-500">
                                        <path
                                            d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                        </path>
                                        <path d="M22 10v6"></path>
                                        <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1 flex items-start justify-between gap-2">
                                    <div class="min-w-0">
                                        <p class="text-sm font-semibold leading-tight text-gray-700">{{ edu.university }}</p>
                                        <p class="text-xs font-medium mt-0.5 text-gray-700">{{ edu.career }}</p>
                                        <p class="text-xs text-gray-500 mt-0.5">{{ edu.period }}</p>
                                    </div>
                                    <div class="shrink-0 flex items-center gap-1.5">
                                        <button type="button" (click)="openEducationModal(edu)" aria-label="Editar"
                                            class="text-gray-400 hover:text-gray-700 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5">
                                                <path
                                                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                                </path>
                                                <path d="m15 5 4 4"></path>
                                            </svg>
                                        </button>
                                        <button type="button" (click)="deleteEducation(edu)" aria-label="Eliminar"
                                            class="text-gray-400 hover:text-red-600 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-trash-2 w-3.5 h-3.5">
                                                <path d="M3 6h18"></path>
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                                </path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="sortedEducation.length > educationVisibleCount" class="mt-3 flex justify-center">
                            <button type="button" (click)="showMoreEducation()"
                                class="inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                {{ "words.see-more" | translate }} {{ sortedEducation.length - educationVisibleCount }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                    <path d="m6 9 6 6 6-6"></path>
                                </svg>
                            </button>
                        </div>
                        <div *ngIf="education.length" class="my-4 border-t border-gray-100"></div>
                        <button *ngIf="education.length" type="button" (click)="openEducationModal()"
                            class="w-full flex items-center gap-2 text-left group  justify-start">
                            <span class="w-7 h-7 shrink-0 rounded-md border border-dashed border-gray-600 flex items-center justify-center text-gray-700 group-hover:border-gray-400 group-hover:text-gray-600 transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-3.5 h-3.5">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                            </span>
                            <span class="text-sm font-semibold text-gray-700 group-hover:opacity-80 transition">{{ "words.add-education" | translate }}</span>
                        </button>
                        <!-- Empty state: sin educación -->
                        <div *ngIf="!education.length"
                            class="rounded-lg border border-dashed border-gray-300 p-6 flex flex-col items-center text-center">
                            <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-graduation-cap w-5 h-5 text-gray-400">
                                    <path
                                        d="M21.42 10.922a1 1 0 0 0-.019-1.838L12.83 5.18a2 2 0 0 0-1.66 0L2.6 9.08a1 1 0 0 0 0 1.832l8.57 3.908a2 2 0 0 0 1.66 0z">
                                    </path>
                                    <path d="M22 10v6"></path>
                                    <path d="M6 12.5V16a6 3 0 0 0 12 0v-3.5"></path>
                                </svg>
                            </div>
                     
                            <p class="mt-1 text-xs text-gray-500 max-w-xs">{{ "words.add-education-empty" | translate }}</p>
                            <button type="button" (click)="openEducationModal()"
                                class="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                                {{ "words.add-education" | translate }}
                            </button>
                        </div>
                    </div>

                    <!-- ===== Certificaciones externas (vista completa) ===== -->
                    <div *ngIf="profileSubTab === 'certifications'">
                       
                        <div *ngIf="externalCerts.length" class="space-y-2">
                            <div *ngFor="let cert of sortedExternalCerts | slice:0:externalCertsVisibleCount"
                                class="flex items-start gap-3 rounded-lg border border-gray-200 p-3">
                                <span
                                    class="w-11 h-11 shrink-0 rounded-lg bg-gray-100 flex items-center justify-center overflow-hidden">
                                    <img *ngIf="cert.logo" [src]="cert.logo" [alt]="cert.org" loading="lazy"
                                        class="w-9 h-9 object-contain">
                                    <svg *ngIf="!cert.logo" xmlns="http://www.w3.org/2000/svg" width="24" height="24"
                                        viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"
                                        stroke-linecap="round" stroke-linejoin="round"
                                        class="lucide lucide-award w-5 h-5 text-gray-500">
                                        <path
                                            d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                        </path>
                                        <circle cx="12" cy="8" r="6"></circle>
                                    </svg>
                                </span>
                                <div class="min-w-0 flex-1 flex items-start justify-between gap-2">
                                    <div class="min-w-0">
                                        <p class="text-sm font-semibold leading-tight text-gray-700">{{ cert.title }}</p>
                                        <p class="text-xs text-gray-500 mt-0.5">{{ cert.org }} · {{ cert.date }}</p>
                                    </div>
                                    <div class="shrink-0 flex items-center gap-1.5">
                                        <button type="button" (click)="openCertificationModal(cert)" aria-label="Editar"
                                            class="text-gray-400 hover:text-gray-700 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-pencil w-3.5 h-3.5">
                                                <path
                                                    d="M21.174 6.812a1 1 0 0 0-3.986-3.987L3.842 16.174a2 2 0 0 0-.5.83l-1.321 4.352a.5.5 0 0 0 .623.622l4.353-1.32a2 2 0 0 0 .83-.497z">
                                                </path>
                                                <path d="m15 5 4 4"></path>
                                            </svg>
                                        </button>
                                        <button type="button" (click)="deleteCertification(cert)" aria-label="Eliminar"
                                            class="text-gray-400 hover:text-red-600 transition-colors">
                                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                                fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                                stroke-linejoin="round" class="lucide lucide-trash-2 w-3.5 h-3.5">
                                                <path d="M3 6h18"></path>
                                                <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2">
                                                </path>
                                            </svg>
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div *ngIf="sortedExternalCerts.length > externalCertsVisibleCount" class="mt-3 flex justify-center">
                            <button type="button" (click)="showMoreExternalCerts()"
                                class="inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                {{ "words.see-more" | translate }} {{ sortedExternalCerts.length - externalCertsVisibleCount }}
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-chevron-down w-3.5 h-3.5">
                                    <path d="m6 9 6 6 6-6"></path>
                                </svg>
                            </button>
                        </div>
                        <div *ngIf="externalCerts.length" class="my-4 border-t border-gray-100"></div>
                        <button *ngIf="externalCerts.length" type="button" (click)="openCertificationModal()"
                            class="w-full flex items-center gap-2 text-left group  justify-start">
                            <span class="w-7 h-7 shrink-0 rounded-md border border-dashed border-gray-600 flex items-center justify-center text-gray-700 group-hover:border-gray-400 group-hover:text-gray-600 transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-3.5 h-3.5">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                            </span>
                            <span class="text-sm font-semibold text-gray-700 group-hover:opacity-80 transition">{{ "words.add-certification" | translate }}</span>
                        </button>
                        <!-- Empty state: sin certificaciones -->
                        <div *ngIf="!externalCerts.length"
                            class="rounded-lg border border-dashed border-gray-300 p-6 flex flex-col items-center text-center">
                            <div class="w-12 h-12 rounded-full bg-gray-100 flex items-center justify-center mb-3">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-award w-5 h-5 text-gray-400">
                                    <path
                                        d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526">
                                    </path>
                                    <circle cx="12" cy="8" r="6"></circle>
                                </svg>
                            </div>
                         
                            <p class="mt-1 text-xs text-gray-500 max-w-xs">{{ "words.add-certification-empty" | translate }}</p>
                            <button type="button" (click)="openCertificationModal()"
                                class="mt-3 inline-flex items-center gap-1.5 rounded-full border border-gray-300 bg-white px-4 py-2 text-xs font-semibold text-gray-700 gk-btn-outline transition">
                                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24"
                                    fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round"
                                    stroke-linejoin="round" class="lucide lucide-plus w-4 h-4">
                                    <path d="M5 12h14"></path>
                                    <path d="M12 5v14"></path>
                                </svg>
                                {{ "words.add-certification" | translate }}
                            </button>
                        </div>
                    </div>
                    </div>
                </div>

            </section>
        </div>
    </main>
</div>
<!-- Footer de la página -->
<app-footer></app-footer>